<div class="n-oldalfej">
  <h2>{{ nezetCim }}</h2>
  <span class="n-alcim">{{ nezetFomenu }} · kettős könyvvitel</span>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business"></ion-icon>Válassz ügyfelet.</div>

<!-- ═════════════ KÖNYVELÉS: napló-fülek, könyvelő ablak, a napló bizonylatai ═════════════ -->
<div *ngIf="aktiv.ugyfelId && nezet === 'kontir'">
  <div class="n-fulek">
    <!--  Nyitatlan évben csak a nyitó napló él (a nyitó egyenlegek rögzítéséhez). -->
    <button *ngFor="let n of naplok" type="button" [class.aktiv]="aktivNaplo === n.value"
            [class.tiltott]="naploTiltott(n.value)" [disabled]="naploTiltott(n.value)"
            [title]="naploTiltott(n.value) ? 'Amíg az év nincs megnyitva, csak a nyitó napló rögzíthető.' : ''"
            (click)="naploValt(n.value)">{{ n.label }}</button>
  </div>

  <app-szerk-zar-sav *ngIf="szerk" [zar]="zarTetel"></app-szerk-zar-sav>
  <form class="kv" *ngIf="szerk" #urlap (keydown.enter)="enterTovabb($event)" (ngSubmit)="mentTetel()" autocomplete="off">
    <!-- A számlatükör EGYSZER, a szerkesztő gyökerében (2026-11-05): eddig két példányban (2×600+ option) a Számlasorok
         fülön és a lépések kártyáján – a Kontírozás fülön és a számlasor-ablakban pedig nem volt javaslat. -->
    <datalist id="szlaLista"><option *ngFor="let t of tukor; trackBy: tukorTrack" [value]="t.szamlaszam" [disabled]="t.gyujto">{{ t.nev }}</option></datalist>
    <div class="kv-fej">
      <button type="button" class="kv-vissza" *ngIf="visszaUt" (click)="visszaNaplo(szerk.id)" title="Vissza a naplóhoz (mentés nélkül)"><ion-icon name="arrow-back"></ion-icon>Vissza a naplóhoz</button>
      <span class="kv-cim">{{ szerk.id ? 'Bizonylat módosítása' : 'Új bizonylat' }}</span>
      <span class="kv-sorszam">{{ szerk.id ? naplosorszam(szerk) : 'a sorszámot mentéskor kapja' }}</span>
      <span class="kv-osa" *ngIf="szerk.osa_szamlaszam"><ion-icon name="cloud-done-outline"></ion-icon> OSA: {{ szerk.osa_szamlaszam }}</span>
      <span class="kv-osa" *ngIf="szerk.eloleg_szamlaszam" title="A végszámlához kapcsolt előlegszámla"><ion-icon name="link-outline"></ion-icon> Előleg: {{ szerk.eloleg_szamlaszam }}</span>
      <span class="kv-osa kv-storno" *ngIf="modositoPar" title="Mentéskor az eredetihez kötjük – a kettő együtt érvényes">
        <ion-icon name="link-outline"></ion-icon> Módosító számla → eredeti: {{ modositoPar.eredeti_szamlaszam }}</span>
      <ng-container *ngIf="szamlaKapcsolat">
        <button type="button" class="kv-osa kv-kapcsolat" *ngIf="szamlaKapcsolat.eredeti" (click)="kapcsoltNyit(szamlaKapcsolat.eredeti.eredeti_tetel_id)"
                title="Ez egy módosító számla – az eredetivel együtt érvényes. Kattintásra megnyílik az eredeti.">
          <ion-icon name="link-outline"></ion-icon> Módosítja: {{ szamlaKapcsolat.eredeti.eredeti_szamlaszam }}</button>
        <button type="button" class="kv-osa kv-kapcsolat" *ngFor="let m of szamlaKapcsolat.modositok" (click)="kapcsoltNyit(m.tetel_id)"
                [title]="m.tetel_id ? 'Módosító számla – kattintásra megnyílik' : '0 Ft-os módosító, könyvelés nélkül csatolva (' + m.csatolva + ')'">
          <ion-icon name="link-outline"></ion-icon> Módosítva: {{ m.szamlaszam }} ({{ +m.osszeg > 0 ? '+' : '' }}{{ m.osszeg | number:'1.0-2' }})</button>
      </ng-container>
      <label class="kv-osa kv-storno" *ngIf="stornoPar" title="A storno az eredeti tükreként könyvelődik: ugyanazok a számlák ellentétes oldalon – 0 egyenleg">
        <input type="checkbox" [(ngModel)]="stornoParJelol" name="stornoParJelol">
        Sztornózva ({{ stornoPar.szamlaszam }}) – a storno is könyvelődjön vele</label>
      <div class="spacer"></div>
      <button type="button" class="kv-behuz" (click)="osaIndit()" title="Számla behúzása a NAV Online Számla rendszeréből – a lekérés automatikus">
        <ion-icon name="cloud-download-outline"></ion-icon>Számla behúzása (NAV)
      </button>
      <label class="kv-jel"><input type="checkbox" name="devizas" [(ngModel)]="szerk.devizas" (ngModelChange)="devizaValt()"> Devizás tétel</label>
      <label class="kv-jel"><input type="checkbox" name="elteroafa" [(ngModel)]="elteroAfa" (ngModelChange)="teljesitesValt()"> Eltérő ÁFA-esedékesség</label>
      <!-- ADOTT ELŐLEG (különleges kontír): a fő bizonylat banki lesz (T 383 / K 384X bruttó), mellette a vegyes ÁFA-lépés. -->
      <label class="kv-jel" *ngIf="szerk.naplo_tipus === 'szallito' || szerk.naplo_tipus === 'vevo' || elolegJel"
             title="Előlegszámla: a bankból könyveljük bruttóban – adott előlegnél T 383 / K bank, mellette vegyes T 466 / K 3572; kapott előlegnél T bank / K 453, mellette vegyes T 3571 / K 467. Az „előleg” szót tartalmazó számlánál magától bepipálódik.">
        <input type="checkbox" name="eloleg" [(ngModel)]="elolegJel" (ngModelChange)="elolegValt($event)"> Előleg</label>
      <button type="button" class="kv-ikon" (click)="ujTetel(); urlapFokusz()" title="Új, üres bizonylat"><ion-icon name="add"></ion-icon></button>
    </div>

    <div class="kv-test">
      <div class="kv-fo">
        <div class="kv-felso">
          <div class="kv-panel">
            <label class="kv-mezo"><span>Főkönyvi szám</span>
              <span class="kv-egyutt">
                <input name="foszamla" class="kv-kod" [(ngModel)]="szerk.foszamla" placeholder="pl. 311">
                <span class="kv-szlanev">{{ szamlaNev(szerk.foszamla) || '—' }}</span>
                <button type="button" class="kv-gomb" (click)="nyitSzlaValaszto({ fo: true })" title="Választás a számlatükörből"><ion-icon name="list"></ion-icon></button>
              </span>
            </label>
            <label class="kv-mezo"><span>Számla kelte</span><input type="date" name="datum" [(ngModel)]="szerk.datum" (change)="keltValt()"></label>
            <label class="kv-mezo"><span>Teljesítés</span><input type="date" name="telj" [(ngModel)]="szerk.teljesites" (ngModelChange)="teljesitesValt()"></label>
            <label class="kv-mezo"><span>ÁFA esed.</span><input type="date" name="afadatum" [(ngModel)]="szerk.afa_datum" [readonly]="!elteroAfa" [class.kv-ro]="!elteroAfa"></label>
            <label class="kv-mezo"><span>Fizetési hat.</span><input type="date" name="hatarido" [(ngModel)]="szerk.hatarido"></label>
            <label class="kv-mezo" title="A NAV-számlából (Online Számla) töltődik, ha onnan könyvelsz"><span>Fizetési mód</span>
              <select name="fizmod" [(ngModel)]="szerk.fizmod">
                <option [ngValue]="null">—</option>
                <option *ngFor="let f of fizmodok" [ngValue]="f.ertek">{{ f.cim }}</option>
              </select></label>
          </div>
          <div class="kv-panel">
            <div class="kv-deviza" *ngIf="szerk.devizas">
              <label class="kv-mezo"><span>Devizanem</span>
                <select name="deviza" [(ngModel)]="szerk.deviza" (ngModelChange)="arfolyamFrissit()">
                  <option *ngFor="let d of ['EUR','USD','GBP','CHF','RON','PLN','CZK','SEK','NOK','DKK']" [value]="d">{{ d }}</option>
                </select>
              </label>
              <label class="kv-mezo"><span>Árfolyam</span>
                <span class="kv-egyutt">
                  <input type="number" step="0.0001" name="arfolyam" [(ngModel)]="szerk.arfolyam" placeholder="auto">
                  <button type="button" class="kv-gomb" (click)="arfolyamFrissit()" title="MNB-árfolyam a számla keltére">MNB</button>
                </span>
              </label>
            </div>
            <label class="kv-mezo"><span>Bizonylatsz.</span><input name="biz" [(ngModel)]="szerk.bizonylatszam" (ngModelChange)="bizEllenoriz()"></label>
            <!-- Azonnal (gépelés közben) szól, ha ilyen számú bizonylatot már könyveltek – nem csak mentéskor. -->
            <div class="kv-figyel" *ngIf="bizDupla.length">
              {{ szerk.id ? 'Ugyanezzel a számlaszámmal másik bizonylat is van' : 'Ez a számlaszám már könyvelve' }}:
              <ng-container *ngFor="let t of bizDupla; let u = last">{{ naploNevBiz(t.naplo_tipus) }} napló {{ t.sorszam }}. ({{ t.datum | date:'yyyy.MM.dd' }}{{ t.partner_nev ? ', ' + t.partner_nev : '' }}{{ t.megnevezes ? ' – ' + t.megnevezes : '' }}){{ u ? '' : '; ' }}</ng-container>
            </div>
            <label class="kv-mezo" title="A bizonylat minden sorára érvényes, ha a számlasoron nincs külön megadva">
              <span>Munkaszám</span><input name="msz" [(ngModel)]="szerk.munkaszam" list="kvMszLista" maxlength="10" placeholder="– nincs –"></label>
            <datalist id="kvMszLista"><option *ngFor="let m of munkaszamok" [value]="m.kod">{{ m.nev }}</option></datalist>
            <label class="kv-mezo"><span>Partner</span>
              <span class="kv-egyutt">
                <input name="partner" readonly [value]="szerk.partner_nev || ''" placeholder="– nincs –" (click)="partnerPickerNyit()" class="kv-valaszto">
                <button type="button" class="kv-gomb" (click)="partnerPickerNyit()" title="Választás a partnertörzsből"><ion-icon name="search"></ion-icon></button>
                <button type="button" class="kv-gomb" *ngIf="szerk.partner_nev" (click)="partnerTorles()" title="Partner törlése"><ion-icon name="close"></ion-icon></button>
              </span>
            </label>
            <div class="kv-figyel" *ngIf="partnerHianyzik">Nincs a törzsben. <a (click)="partnerFelvesz()">Létrehozás „{{ szerk.partner_nev }}" néven</a></div>
            <label class="kv-mezo"><span>Megjegyzés</span><input name="megnev" [(ngModel)]="szerk.megnevezes" (blur)="javaslatFrissit()"></label>
            <!-- Végszámlánál: a kapcsolódó ELŐLEGSZÁMLA száma. Vevői végszámlánál a KAPOTT előleg (453/479),
                 szállítóinál az ADOTT előleg (35x) könyvelt tételeiből választva, vagy kézzel megadva. -->
            <label class="kv-mezo" *ngIf="szerk.naplo_tipus === 'vevo' || szerk.naplo_tipus === 'szallito' || szerk.naplo_tipus === 'vegyes'"
                   title="Ha ez végszámla: ide kerül a kapcsolódó előlegszámla száma. Vevői végszámlánál a kapott előleg, szállítóinál az adott előleg könyvelt bizonylataiból választható, vagy kézzel is megadható.">
              <span>Előlegszámla</span>
              <input name="elolegszla" [(ngModel)]="szerk.eloleg_szamlaszam" list="kvElolegLista" (focus)="elolegSzamlakBetolt()" (change)="vegszamlaElolegValt()" placeholder="– nincs –">
            </label>
            <datalist id="kvElolegLista"><option *ngFor="let e of elolegSzamlak" [value]="e.bizonylatszam">{{ e.partner_nev }} · {{ e.osszeg | number:'1.0-0' }} Ft · {{ e.datum }}</option></datalist>
            <!-- KÉZI MÓDOSÍTÓ/STORNO ÖSSZEKÖTÉS: ha ez módosító vagy sztornó számla, az EREDETI bizonylat száma.
                 Mentéskor összekötjük – az eredetivel együtt érvényes (akár 0 Ft-os végösszegnél is). -->
            <label class="kv-mezo" *ngIf="szerk.naplo_tipus === 'vevo' || szerk.naplo_tipus === 'szallito'"
                   title="Ha ez módosító vagy sztornó számla: ide az eredeti bizonylat száma. Mentéskor összekötjük az eredetivel.">
              <span>Módosít / sztornóz</span>
              <input name="eredetibiz" [(ngModel)]="szerk.eredeti_bizonylatszam" placeholder="eredeti bizonylatszám – nincs –">
            </label>
          </div>
        </div>

        <div class="kv-figyel kv-lepes-tag" *ngIf="kapcsoltFo">
          Ez a bizonylat egy {{ kapcsoltFo.kapcsolat_szerep === 'eloleg' ? 'adott előleg' : 'végszámla' }} kapcsolt lépése – a fő bizonylattal együtt módosítható.
          <a (click)="szerkTetel({ id: kapcsoltFo.id })">A fő bizonylat megnyitása</a>
        </div>
        <!-- FÜLEK -->
        <div class="kv-fulek">
          <button type="button" *ngIf="szamlasoros" [class.aktiv]="ful === 'szamlasor'" (click)="ful = 'szamlasor'">Számlasorok</button>
          <button type="button" [class.aktiv]="ful === 'kontir'" (click)="ful = 'kontir'">Kontírozás <span class="kv-kezi" *ngIf="kontirKezi && szamlasoros">kézi</span></button>
          <button type="button" [class.aktiv]="ful === 'kep'" (click)="ful = 'kep'">Számlakép</button>
          <div class="kv-javaslat" *ngIf="javaslatok.length && ful !== 'kep'">
            <span>Tanult számlák:</span>
            <button type="button" *ngFor="let jj of javaslatok" (click)="javaslatSzamlasorra(jj)" [title]="jj.nev">
              <b>{{ jj.szamlaszam }}</b> {{ jj.nev }}<small *ngIf="jj.gyakorisag"> · {{ jj.gyakorisag }}×</small>
            </button>
          </div>
        </div>

        <!-- SZÁMLASOROK -->
        <div class="kv-racs" *ngIf="ful === 'szamlasor' && szamlasoros">
          <table class="n-racs">
            <thead><tr>
              <th style="width:34px">#</th><th>Megjegyzés</th><th style="width:90px">ÁFA %</th><th style="width:230px">Fők.sz. ({{ szerk.naplo_tipus === 'vevo' ? 'bevétel' : 'költség' }})</th>
              <th class="num" style="width:130px">Nettó</th><th class="num cs-afa" style="width:110px">ÁFA</th><th class="num" style="width:130px">Bruttó</th><th style="width:64px"></th>
            </tr></thead>
            <tbody>
              <tr *ngFor="let x of szamlasorok; let i = index" [class.ures-sor]="i === szamlasorok.length - 1">
                <td class="kv-ssz">{{ i + 1 }}.</td>
                <td><input class="kv-cella" [name]="'megj' + i" [(ngModel)]="x.megj" (ngModelChange)="szamlasorValt()" placeholder="tétel megnevezése"></td>
                <!--  Nem áfaalany cégnél csak a fordított adózás (FAD) és az adómentes kódok jöhetnek szóba:
                      ÁFA-kulcsot nem választhat, mert bruttóban könyvelünk. -->
                <td><select class="kv-cella" [name]="'k' + i" [(ngModel)]="x.afa_v" (ngModelChange)="x.afas = afasTetelLehet; afaValt(x)" [title]="x.afa_kod || ''">
                  <option *ngFor="let a of (afasTetelLehet ? afaValasztek : afaValasztekNemAfas)" [value]="a.v">{{ a.kod || a.c }}</option></select>
                  <div class="kv-cella-nev" *ngIf="x.bev_sor || x.osszesito" [title]="bevTanultCim(x)">{{ x.bev_sor ? 'bev.sor ' + x.bev_sor : '' }}<span class="bevsor-tanult" *ngIf="bevTanultLatszik(x)">tanult</span>{{ x.osszesito ? ' · össz. nyil.' : '' }}</div></td>
                <td><span class="kv-egyutt">
                  <input class="kv-cella kod" [name]="'fok' + i" [(ngModel)]="x.fok" (ngModelChange)="szamlasorValt()" list="szlaLista" placeholder="{{ szerk.naplo_tipus === 'vevo' ? '911' : '511' }}">
                  <button type="button" class="kv-mini" (click)="nyitSzlaValaszto({ szamlasor: x })" title="Választás a számlatükörből"><ion-icon name="list-outline"></ion-icon></button>
                </span><div class="kv-cella-nev" *ngIf="x.fok">{{ szamlaNev(x.fok) || 'nincs ilyen számla' }}</div></td>
                <td class="num"><input class="kv-cella num" type="number" step="0.01" [name]="'n' + i" [(ngModel)]="x.netto" (blur)="szamlasorSzamol(x, 'netto')"></td>
                <td class="num cs-afa"><input class="kv-cella num" type="number" step="0.01" [name]="'a' + i" [(ngModel)]="x.afa" (ngModelChange)="x.brutto = (+x.netto || 0) + (+x.afa || 0); szamlasorValt()"></td>
                <td class="num"><input class="kv-cella num" type="number" step="0.01" [name]="'b' + i" [(ngModel)]="x.brutto" (blur)="szamlasorSzamol(x, 'brutto')"></td>
                <td class="kv-sor-muv"><button type="button" class="kv-mini" (click)="sorAblakNyit(i)" title="Számlasor rögzítése (ÁFA-kód, bevallási sor, főkönyvi számok)"><ion-icon name="create-outline"></ion-icon></button>
                  <button type="button" class="kv-torol" *ngIf="i < szamlasorok.length - 1" (click)="szamlasorTorol(i)" title="Sor törlése"><ion-icon name="close"></ion-icon></button></td>
              </tr>
            </tbody>
            <tfoot><tr>
              <td colspan="4" class="kv-ossz-cim">ÖSSZESEN <span class="halvany">{{ szerk.devizas ? '(' + szerk.deviza + ')' : '' }}</span></td>
              <td class="num">{{ fmt0(szamlasorOsszeg('netto')) }}</td><td class="num cs-afa">{{ fmt0(szamlasorOsszeg('afa')) }}</td><td class="num">{{ fmt0(szamlasorOsszeg('brutto')) }}</td><td></td>
            </tr></tfoot>
          </table>
          <div class="kv-szamlasor-lab">
            <button type="button" class="kv-behuz" (click)="sorAblakNyit(null)"><ion-icon name="add"></ion-icon>Új számlasor</button>
            <span class="halvany">A ceruzával a sor részletei: ÁFA-kód, bevallási sor, összesítő nyilatkozat, főkönyvi számok.</span>
          </div>
          <p class="kv-megj" *ngIf="!ugyfelAfas && szerk.naplo_tipus === 'szallito'">Az ügyfél nem áfaalany: a beszerzés ÁFA-ja nem vonható le, a költségre bruttóban kerül.</p>
        </div>

        <!-- KONTÍROZÁS (T/K) -->
        <div *ngIf="ful === 'kontir'" class="kv-kontir">
          <div class="kv-kezi-sav" *ngIf="kontirKezi && szamlasoros">
            <ion-icon name="hand-left-outline"></ion-icon>
            Kézi kontír: a számlasorok módosítása nem írja felül.
            <a (click)="kontirUjraepit()">Újraépítés a számlasorokból</a>
          </div>
          <div class="foszamla-sav">
            <ion-icon name="git-merge-outline"></ion-icon>
            <span class="cimke">Főláb:</span>
            <b>{{ szerk.foszamla || '—' }}</b> <span class="fonev">{{ szamlaNev(szerk.foszamla) || '' }}</span>
            <span class="foosszeg"><b>{{ foOldal }}</b> {{ fmt0(foOsszeg) }}</span>
          </div>
          <table class="n-racs kv-tk">
            <thead><tr><th style="width:150px">Főkönyvi szám</th><th>Megnevezés</th><th class="num" style="width:140px">Összeg</th><th style="width:70px">T/K</th><th style="width:80px">ÁFA %</th><th style="width:36px"></th></tr></thead>
            <tbody>
              <tr *ngFor="let x of szerk.sorok; let i = index">
                <td><span class="kv-egyutt">
                  <input class="kv-cella kod" [name]="'tsz' + i" [(ngModel)]="x.szamlaszam" (ngModelChange)="kontirKezzel()" placeholder="pl. 511">
                  <button type="button" class="kv-mini" (click)="nyitSzlaValaszto({ sor: x }); kontirKezzel()"><ion-icon name="list-outline"></ion-icon></button>
                </span></td>
                <td><input class="kv-cella" [name]="'tmeg' + i" [(ngModel)]="x.megnevezes" (ngModelChange)="kontirKezzel()" [placeholder]="szamlaNev(x.szamlaszam) || 'megnevezés'"></td>
                <td class="num"><input class="kv-cella num" type="number" step="0.01" [name]="'tos' + i" [(ngModel)]="x.osszeg" (ngModelChange)="kontirKezzel()"></td>
                <td><select class="kv-cella" [name]="'told' + i" [(ngModel)]="x.oldal" (ngModelChange)="kontirKezzel()"><option value="T">T</option><option value="K">K</option></select></td>
                <td><input class="kv-cella num" type="number" [name]="'tafa' + i" [(ngModel)]="x.afa_kulcs" (ngModelChange)="kontirKezzel()"></td>
                <td><button type="button" class="kv-torol" (click)="sorTorol(i); kontirKezzel()"><ion-icon name="close"></ion-icon></button></td>
              </tr>
            </tbody>
          </table>
          <div class="kv-kontir-lab">
            <button type="button" class="kv-gomb" (click)="sorHozzaad(); kontirKezzel()"><ion-icon name="add"></ion-icon> Sor</button>
            <span class="spacer"></span>
            <span class="kv-afaseged">ÁFA-segéd:
              <input type="number" name="asalap" [(ngModel)]="afaSeged.alap" placeholder="nettó alap">
              <input type="number" name="askulcs" [(ngModel)]="afaSeged.kulcs" placeholder="%" style="width:60px">
              <label><input type="checkbox" name="asford" [(ngModel)]="afaSeged.fordit"> Fordított</label>
              <button type="button" class="kv-gomb" (click)="afaSorokHozzaad(); kontirKezzel()">ÁFA-sorok</button>
            </span>
          </div>
          <div *ngIf="forditSorok.length" class="kv-fordit">
            Fordított ÁFA – {{ forditMeglevo ? 'külön bizonylaton könyvelve' : 'külön bizonylat készül' }} ({{ fmt0(forditAfa) }}):
            <ng-container *ngFor="let x of forditSorok; let i = index">{{ i ? ' · ' : ' ' }}<b>{{ x.szamlaszam }}</b> {{ x.tartozik ? 'T ' + fmt0(x.tartozik) : 'K ' + fmt0(x.kovetel) }}</ng-container>
            <button type="button" class="kv-torol" *ngIf="!forditMeglevo" (click)="forditTorol()"><ion-icon name="close"></ion-icon></button>
          </div>
        </div>

        <!-- KÜLÖNLEGES KONTÍR: a fő bizonylattal együtt mentődő kapcsolt lépések (javíthatók). -->
        <div class="kv-lepesek" *ngIf="lepesek.length && ful !== 'kep'">
          <div class="kv-lepes-fej">
            <b>Kapcsolódó lépések</b> – {{ kapcsolatSzerep === 'eloleg' ? (elolegKapott ? 'kapott előleg' : 'adott előleg') : 'végszámla, előleg-beszámítással' }}
            <span class="halvany">1. lépés a fenti bizonylat ({{ naploNevBiz(szerk.naplo_tipus) }} napló){{ kapcsolatSzerep === 'vegszamla' ? ' – a beszámítás ennek a 2. tétele' : '' }}. A többi vele együtt mentődik; itt javítható.</span>
          </div>
          <div class="kv-lepes" *ngFor="let l of lepesek; let li = index">
            <div class="kv-lepes-cim">
              <b>{{ l.naplo_tipus === 'fo' ? '2. tétel' : (li + 2) + '. lépés' }}</b>
              <span class="halvany" *ngIf="l.naplo_tipus === 'fo'">a végszámla bizonylatában</span>
              <select *ngIf="l.naplo_tipus !== 'fo'" [name]="'lnap' + li" [(ngModel)]="l.naplo_tipus"><option value="vegyes">Vegyes</option><option value="bank">Bank</option><option value="szallito">Szállítói</option></select>
              <input class="kv-lepes-megn" [name]="'lmeg' + li" [(ngModel)]="l.megnevezes" placeholder="megnevezés">
              <span class="kv-lepes-egy" [class.hibas]="!lepesEgyensuly(l)">T {{ fmt0(lepesOldal(l, 'T')) }} · K {{ fmt0(lepesOldal(l, 'K')) }}</span>
              <button type="button" class="kv-torol" (click)="lepesek.splice(li, 1)" title="Lépés elhagyása"><ion-icon name="close"></ion-icon></button>
            </div>
            <div class="kv-lepes-sor" *ngFor="let s of l.sorok; let si = index">
              <select [name]="'lo' + li + '_' + si" [(ngModel)]="s.oldal"><option value="T">T</option><option value="K">K</option></select>
              <input class="kod" [name]="'ls' + li + '_' + si" [(ngModel)]="s.szamlaszam" list="szlaLista">
              <span class="kv-lepes-nev" [class.hibas]="!szamlaNev(s.szamlaszam)">{{ szamlaNev(s.szamlaszam) || 'nincs ilyen számla a tükörben' }}</span>
              <input class="num" type="number" step="1" [name]="'lb' + li + '_' + si" [(ngModel)]="s.osszeg">
            </div>
          </div>
        </div>

        <!-- SZÁMLAKÉP -->
        <div *ngIf="ful === 'kep'" class="kv-kep">
          <ion-button type="button" size="small" fill="outline" *ngIf="szerk.id && szerk.kep_object" (click)="tetelKep(szerk)"><ion-icon slot="start" name="reader"></ion-icon>Számlakép ({{ szerk.kep_nev || 'PDF' }})</ion-button>
          <ion-button type="button" size="small" fill="outline" *ngIf="szerk.osa_szamlaszam" (click)="osaSzamlakep({ szamlaszam: szerk.osa_szamlaszam, irany: szerk.osa_irany })" title="A csatolt eredeti számlakép (ha van); ennek híján a generált nézet"><ion-icon slot="start" name="document-text"></ion-icon>Számlakép (OSA)</ion-button>
          <span class="halvany" *ngIf="!szerk.kep_object && !szerk.osa_szamlaszam">Ehhez a bizonylathoz nincs számlakép. A Dokumentumtárból vagy az Online Számla (OSA) listából könyvelt bizonylat képe itt nyílik meg.</span>
        </div>
      </div>

      <!-- ÖSSZESÍTŐ -->
      <aside class="kv-oldal">
        <div class="kv-ossz-sor"><span>Nettó</span><b>{{ fmt0(szamlasoros ? szamlasorOsszeg('netto') : kSum) }}</b></div>
        <div class="kv-ossz-sor"><span>ÁFA</span><b>{{ fmt0(szamlasoros ? szamlasorOsszeg('afa') : 0) }}</b></div>
        <div class="kv-ossz-sor fo"><span>Bruttó</span><b>{{ fmt0(foOsszeg) }}</b></div>
        <div class="kv-ossz-sor" *ngIf="szerk.devizas"><span>Forintban</span><b>{{ fmt0(hufErtek(foOsszeg)) }}</b></div>
        <div class="kv-egyensuly" [class.ok]="egyensulyban">
          <span>T {{ fmt0(tSum) }}</span><span>K {{ fmt0(kSum) }}</span>
          <b>{{ egyensulyban ? '✓ egyensúlyban' : '✗ nincs egyensúlyban' }}</b>
        </div>
        <ion-button type="submit" expand="block" [disabled]="!egyensulyban || zarTilt(zarTetel)"><ion-icon slot="start" name="save-outline"></ion-icon>Tétel mentése / Új tétel</ion-button>
        <ion-button type="button" expand="block" fill="outline" size="small" *ngIf="szerk.id" (click)="hozamTetel = szerk.id"
                    title="A bizonylat (vagy egyes sorai) egy tárgyi eszköz bérleti díja vagy kiadása – a megtérülési kimutatáshoz">
          <ion-icon slot="start" name="construct-outline"></ion-icon>Tárgyi eszközhöz</ion-button>
      </aside>
    </div>
  </form>

  <!-- A napló bizonylatai -->
  <div class="n-szuro-sor"><label>{{ naploCim(aktivNaplo).replace(' könyvelése', '') }} – bizonylatok ({{ aktiv.ev }})</label><span class="spacer"></span><span class="halvany">{{ tetelek.length }} db</span></div>
  <div class="tabla-wrap kv-lista">
    <table class="n-racs">
      <thead><tr><th>Naplósorszám</th><th>Dátum</th><th>Bizonylat</th><th>Partner</th><th>Megnevezés</th><th class="num">Összeg</th><th></th></tr></thead>
      <tbody>
        <!-- Nagy naplónál a legutóbbi bizonylatok (2026-11-05) – a korábbiak egy kattintással. -->
        <tr *ngIf="tetelek.length > tetelLap" class="kv-korabbi"><td colspan="7">
          <button type="button" class="ov-gomb" (click)="tetelLap = tetelLap + 200">
            <ion-icon name="chevron-up-outline"></ion-icon>Korábbi {{ tetelek.length - tetelLap > 200 ? 200 : tetelek.length - tetelLap }} bizonylat
            ({{ tetelek.length - tetelLap }} nem látszik)</button></td></tr>
        <tr *ngFor="let t of rajzoltTetelek; trackBy: tetelTrack" [class.kijelolt]="t.id === szerk?.id" (click)="szerkTetel(t)" style="cursor:pointer" title="Megnyitás szerkesztésre">
          <td>{{ naplosorszam(t) }}</td><td>{{ t.datum | date:'yyyy.MM.dd' }}</td><td>{{ t.bizonylatszam }}</td>
          <td>{{ t.partner_nev }}</td><td class="halvany">{{ t.megnevezes }}</td>
          <td class="num">{{ fmt0(t.osszeg) }}</td>
          <td (click)="$event.stopPropagation()" style="white-space:nowrap">
            <button type="button" class="kv-torol" *ngIf="t.kep_object" (click)="tetelKep(t)" title="Számlakép"><ion-icon name="reader-outline"></ion-icon></button>
            <button type="button" class="kv-torol" (click)="torolTetel(t)" [disabled]="t.id === szerk?.id && zarTilt(zarTetel)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="ures" *ngIf="!tetelek.length"><ion-icon name="document-outline"></ion-icon>Nincs bizonylat ebben a naplóban.</div>
  </div>
</div>

<!-- SZÁMLA BEHÚZÁSA A NAV-BÓL – közös választó (osa-valaszto), az egyszeres könyveléssel azonos.
     A NAV-kulcsok a Törzsadatok → NAV technikai felhasználó képernyőn (mindkét módban ugyanott),
     a partnertörzs és a NAV törzsadat is közös (torzsek). -->
<ion-modal #osaModal cssClass="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Számla behúzása a NAV-ból (Online Számla)</ion-title>
      <ion-buttons slot="end"><ion-button (click)="osaModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <app-naplo-osa-valaszto [ugyfelId]="aktiv.ugyfelId" [ev]="aktiv.ev" [konyveltSzamlak]="osaKonyveltSet" [csatoltSzamlak]="osaCsatoltSet"
        [irany]="aktivNaplo === 'vevo' ? 'outbound' : 'inbound'" [tomeges]="true"
        (konyvel)="osaValasztKonyvel($event)" (csatol)="osaCsatol($event)" (tomegesKonyvel)="osaTomeges($event)" (kep)="osaSzamlakep($event)">
      </app-naplo-osa-valaszto>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- FŐKÖNYVI KIVONAT -->
<ng-container *ngIf="aktiv.ugyfelId && nezet === 'kivonat'">
  <div class="n-szuro-sor kivonat-sav">
    <button type="button" class="ov-gomb" (click)="kivonatSzukitesNyit()"><ion-icon name="funnel-outline"></ion-icon>Szűkítés</button>
    <label title="Alapból csak az értékkel bíró sorok látszanak. Bekapcsolva a forgalom nélküli gyűjtő (összesítő) számlák is megjelennek.">
      <input type="checkbox" [ngModel]="kivonatSzuro.mind" (ngModelChange)="kivonatMindValt($event)"> Mindent mutat</label>
    <span class="kivonat-chip" *ngFor="let c of kivonatSzuroCimkek">{{ c }}</span>
    <button *ngIf="kivonatSzuroCimkek.length" type="button" class="kivonat-torol" (click)="kivonatSzuroTorol()">
      <ion-icon name="close-circle-outline"></ion-icon>szűkítés törlése</button>
    <span class="spacer"></span>
    <span class="halvany">{{ kivonat.sorok.length }} sor</span>
  </div>

  <!-- Egy sor cellái – a fő sor és az alábontott sor ugyanígy néz ki. -->
  <ng-template #kivonatCellak let-r>
    <ng-container *ngIf="kivonatDeviza">
      <td class="num">{{ (r.nyito_t + r.tartozik) || '' | number:'1.0-0' }}</td>
      <td class="num">{{ (r.nyito_k + r.kovetel) || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.egyenleg_t || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.egyenleg_k || '' | number:'1.0-0' }}</td>
      <td class="kozep" [class.tobb-deviza]="r.deviza === '***'"
          [title]="r.deviza === '***' ? 'Több devizanem – a devizás összesítés nem végezhető el' : ''">{{ r.deviza || '' }}</td>
      <td class="num">{{ r.dev_tartozik || '' | number:'1.2-2' }}</td>
      <td class="num">{{ r.dev_kovetel || '' | number:'1.2-2' }}</td>
      <td class="num">{{ (r.dev_tartozik > r.dev_kovetel ? r.dev_tartozik - r.dev_kovetel : 0) || '' | number:'1.2-2' }}</td>
      <td class="num">{{ (r.dev_kovetel > r.dev_tartozik ? r.dev_kovetel - r.dev_tartozik : 0) || '' | number:'1.2-2' }}</td>
    </ng-container>
    <ng-container *ngIf="!kivonatDeviza && kivonatNyolc">
      <td class="num">{{ r.nyito_t || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.nyito_k || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.tartozik || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.kovetel || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.forg_egyenleg_t || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.forg_egyenleg_k || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.egyenleg_t || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.egyenleg_k || '' | number:'1.0-0' }}</td>
    </ng-container>
    <ng-container *ngIf="!kivonatDeviza && !kivonatNyolc">
      <td class="num">{{ r.nyito || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.tartozik || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.kovetel || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.egyenleg_t || '' | number:'1.0-0' }}</td>
      <td class="num">{{ r.egyenleg_k || '' | number:'1.0-0' }}</td>
    </ng-container>
  </ng-template>

  <div class="tabla-wrap">
    <table class="naplo-tabla kivonat-tabla">
      <thead>
        <tr *ngIf="kivonatDeviza">
          <th rowspan="2">Számla</th><th rowspan="2">Megnevezés</th>
          <th colspan="2" class="csop">Forgalom (Ft)</th><th colspan="2" class="csop">Egyenleg (Ft)</th>
          <th rowspan="2">Deviza</th><th colspan="2" class="csop">Forgalom (deviza)</th><th colspan="2" class="csop">Egyenleg (deviza)</th>
        </tr>
        <tr *ngIf="kivonatNyolc && !kivonatDeviza">
          <th rowspan="2">Számla</th><th rowspan="2">Megnevezés</th>
          <th colspan="2" class="csop">Nyitó</th><th colspan="2" class="csop">Forgalom</th>
          <th colspan="2" class="csop">Forgalom egyenleg</th><th colspan="2" class="csop">Összesen egyenleg</th>
        </tr>
        <tr *ngIf="kivonatDeviza">
          <th class="num">Tartozik</th><th class="num">Követel</th><th class="num">Tartozik</th><th class="num">Követel</th>
          <th class="num">Tartozik</th><th class="num">Követel</th><th class="num">Tartozik</th><th class="num">Követel</th>
        </tr>
        <tr *ngIf="kivonatNyolc && !kivonatDeviza">
          <th class="num">Tartozik</th><th class="num">Követel</th><th class="num">Tartozik</th><th class="num">Követel</th>
          <th class="num">Tartozik</th><th class="num">Követel</th><th class="num">Tartozik</th><th class="num">Követel</th>
        </tr>
        <tr *ngIf="!kivonatNyolc && !kivonatDeviza">
          <th>Számla</th><th>Megnevezés</th><th class="num">Nyitó</th><th class="num">Tartozik</th><th class="num">Követel</th>
          <th class="num">Egyenleg T</th><th class="num">Egyenleg K</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let r of kivonat.sorok">
          <tr [class.gyujto-sor]="r.gyujto" (click)="kartonNyit(r.szamlaszam)" style="cursor:pointer"
              [title]="r.gyujto ? 'Gyűjtő számla – a karton az alá tartozó számlák tételeit mutatja' : 'Főkönyvi karton'">
            <td class="kivonat-szla">
              <button *ngIf="r.albontas" type="button" class="kivonat-nyil" (click)="kivonatKinyit(r, $event)"
                      [title]="kivonatKinyitva.has(r.szamlaszam) ? 'Alábontás elrejtése' : 'Alábontás (' + r.albontas.length + ')'">
                <ion-icon [name]="kivonatKinyitva.has(r.szamlaszam) ? 'chevron-down' : 'chevron-forward'"></ion-icon></button>
              <b *ngIf="r.gyujto">{{ r.szamlaszam }}</b><span *ngIf="!r.gyujto">{{ r.szamlaszam }}</span>
            </td>
            <td>{{ r.nev }} <ion-badge *ngIf="r.gyujto" color="medium">gyűjtő</ion-badge>
              <small *ngIf="r.albontas" class="halvany"> · {{ r.albontas.length }} tétel</small></td>
            <ng-container *ngTemplateOutlet="kivonatCellak; context: { $implicit: r }"></ng-container>
          </tr>
          <ng-container *ngIf="r.albontas && kivonatKinyitva.has(r.szamlaszam)">
            <tr *ngFor="let a of r.albontas" class="albontas-sor">
              <td class="kivonat-szla">{{ a.cimke }}</td>
              <td>{{ a.nev }}</td>
              <ng-container *ngTemplateOutlet="kivonatCellak; context: { $implicit: a }"></ng-container>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
      <tfoot>
        <tr *ngIf="kivonatDeviza"><td colspan="2">Összesen</td>
          <td class="num">{{ kivonat.osszesen.nyito_t + kivonat.osszesen.tartozik | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.nyito_k + kivonat.osszesen.kovetel | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.egyenleg_t | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.egyenleg_k | number:'1.0-0' }}</td>
          <td colspan="5"></td>
        </tr>
        <tr *ngIf="kivonatNyolc && !kivonatDeviza"><td colspan="2">Összesen</td>
          <td class="num">{{ kivonat.osszesen.nyito_t | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.nyito_k | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.tartozik | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.kovetel | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.forg_egyenleg_t | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.forg_egyenleg_k | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.egyenleg_t | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.egyenleg_k | number:'1.0-0' }}</td>
        </tr>
        <tr *ngIf="!kivonatNyolc && !kivonatDeviza"><td colspan="3">Összesen</td>
          <td class="num">{{ kivonat.osszesen.tartozik | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.kovetel | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.egyenleg_t | number:'1.0-0' }}</td>
          <td class="num">{{ kivonat.osszesen.egyenleg_k | number:'1.0-0' }}</td>
        </tr>
      </tfoot>
    </table>
    <div class="ures" *ngIf="!kivonat.sorok.length"><ion-icon name="stats-chart"></ion-icon>
      {{ kivonatSzuroCimkek.length ? 'A szűkítésnek egy tétel sem felel meg.' : 'Még nincs könyvelt forgalom.' }}</div>
  </div>
</ng-container>

<!-- ═══ FŐKÖNYVI KIVONAT – SZŰKÍTÉS (közös ablak, a Naplók kivonata is ezt használja) ═══ -->
<app-kivonat-szukites [nyitva]="kivonatSzukitesNyitva" [szuro]="kivonatSzuro" [ugyfelId]="aktiv.ugyfelId"
  (szukit)="kivonatSzukit($event)" (bezar)="kivonatSzukitesNyitva = false"></app-kivonat-szukites>

<!-- EREDMÉNYKIMUTATÁS -->
<div *ngIf="aktiv.ugyfelId && nezet === 'eredmeny' && eredmeny" class="tabla-wrap">
  <table class="naplo-tabla">
    <thead><tr><th colspan="3">Bevételek (9. számlaosztály)</th></tr></thead>
    <tbody>
      <tr *ngFor="let r of eredmeny.bevetelek"><td>{{ r.szamlaszam }}</td><td>{{ r.nev }}</td><td class="num">{{ r.osszeg | number:'1.0-0' }}</td></tr>
      <tr><td colspan="2"><b>Bevételek összesen</b></td><td class="num"><b>{{ eredmeny.bevetel_ossz | number:'1.0-0' }}</b></td></tr>
      <tr><td colspan="3" style="background:#f0fdfa">Költségek (5.) és ráfordítások (8.)</td></tr>
      <tr *ngFor="let r of eredmeny.koltsegek"><td>{{ r.szamlaszam }}</td><td>{{ r.nev }}</td><td class="num">{{ r.osszeg | number:'1.0-0' }}</td></tr>
      <tr *ngFor="let r of eredmeny.raforditasok"><td>{{ r.szamlaszam }}</td><td>{{ r.nev }}</td><td class="num">{{ r.osszeg | number:'1.0-0' }}</td></tr>
      <tr><td colspan="2"><b>Költségek + ráfordítások</b></td><td class="num"><b>{{ (eredmeny.koltseg_ossz + eredmeny.raforditas_ossz) | number:'1.0-0' }}</b></td></tr>
    </tbody>
    <tfoot><tr><td colspan="2">Adózás előtti eredmény</td><td class="num" [style.color]="eredmeny.eredmeny >= 0 ? '#15803d' : '#b91c1c'"><b>{{ eredmeny.eredmeny | number:'1.0-0' }}</b></td></tr></tfoot>
  </table>
</div>

<!-- MÉRLEG -->
<div *ngIf="aktiv.ugyfelId && nezet === 'merleg' && merleg" class="tabla-wrap">
  <div class="osszeg-sav">
    <div class="item">Eszközök összesen: <b>{{ merleg.eszkoz_ossz | number:'1.0-0' }} Ft</b></div>
    <div class="item">Források összesen: <b>{{ merleg.forras_ossz | number:'1.0-0' }} Ft</b></div>
    <div class="item">Mérleg szerinti eredmény (MSZE): <b [class.neg]="merleg.eredmeny < 0">{{ merleg.eredmeny | number:'1.0-0' }} Ft</b></div>
  </div>
  <!--  EGY táblázat, két hasáb: az eszköz- és a forrásoldal soronként párban, így a két „összesen” egy
        sorba kerül (két külön táblánál a rövidebb oldal összesenje feljebb csúszott – ferde lett a kép). -->
  <table class="naplo-tabla merleg-tabla">
    <thead><tr><th colspan="3">Eszközök</th><th class="merleg-koz"></th><th colspan="3">Források</th></tr></thead>
    <tbody>
      <tr *ngFor="let p of merlegSorok">
        <td>{{ p.e?.szamlaszam }}</td><td>{{ p.e?.nev }}</td><td class="num">{{ p.e ? (p.e.osszeg | number:'1.0-0') : '' }}</td>
        <td class="merleg-koz"></td>
        <td>{{ p.f?.szamlaszam }}</td><td [class.msze]="p.f?.msze">{{ p.f?.nev }}</td>
        <td class="num" [class.msze]="p.f?.msze">{{ p.f ? (p.f.osszeg | number:'1.0-0') : '' }}</td>
      </tr>
    </tbody>
    <tfoot><tr>
      <td colspan="2">Eszközök összesen</td><td class="num">{{ merleg.eszkoz_ossz | number:'1.0-0' }}</td>
      <td class="merleg-koz"></td>
      <td colspan="2">Források összesen</td><td class="num">{{ merleg.forras_ossz | number:'1.0-0' }}</td>
    </tr></tfoot>
  </table>
  <div class="merleg-egyensuly" [class.rossz]="!merleg.egyensuly">
    <ion-icon [name]="merleg.egyensuly ? 'checkmark-circle' : 'alert-circle'"></ion-icon>
    {{ merleg.egyensuly ? 'A mérleg egyensúlyban van.' : 'A mérleg nincs egyensúlyban – ellenőrizd a könyvelést.' }}
  </div>
</div>

<!-- ÁFA-ANALITIKA: szűrők, kulcsonkénti alap / ÁFA, tételek -->
<div *ngIf="aktiv.ugyfelId && nezet === 'afa' && !afaIdoszak" class="afa-idoszak">
  <h3>Melyik időszak ÁFA-analitikáját nézzük? ({{ aktiv.ev }}<span class="halvany" *ngIf="afaNegyedeves"> · negyedéves bevalló</span>)</h3>
  <div class="afa-ido-gombok">
    <button type="button" class="ov-gomb fo" (click)="afaIdoszakValaszt('ev')"><ion-icon name="calendar-outline"></ion-icon>Teljes év</button>
    <ng-container *ngIf="afaNegyedeves">
      <button type="button" class="ov-gomb" *ngFor="let n of afaNegyedek; let i = index" (click)="afaIdoszakValaszt(afaNegyedKod(i))">{{ n }}</button>
    </ng-container>
    <ng-container *ngIf="!afaNegyedeves && !afaEves">
      <button type="button" class="ov-gomb" *ngFor="let h of afaHonapok; let i = index" (click)="afaIdoszakValaszt(afaHoKod(i))">{{ h }}</button>
    </ng-container>
  </div>
</div>
<div *ngIf="aktiv.ugyfelId && nezet === 'afa' && afaIdoszak && afa" class="tabla-wrap">
  <div class="afa-szuro">
    <label>Időszak <select [ngModel]="afaIdoszak" (ngModelChange)="afaIdoszakValaszt($event)">
      <option value="ev">Teljes év</option>
      <ng-container *ngIf="afaNegyedeves"><option *ngFor="let n of afaNegyedek; let i = index" [value]="afaNegyedKod(i)">{{ n }}</option></ng-container>
      <ng-container *ngIf="!afaNegyedeves && !afaEves"><option *ngFor="let h of afaHonapok; let i = index" [value]="afaHoKod(i)">{{ h }}</option></ng-container>
    </select></label>
    <label>ÁFA-dátum <input type="date" [(ngModel)]="afaSzuro.tol"></label>
    <label>– <input type="date" [(ngModel)]="afaSzuro.ig"></label>
    <label>Irány <select [(ngModel)]="afaSzuro.irany"><option value="">mind</option><option value="fizetendo">fizetendő</option><option value="levonhato">levonható</option></select></label>
    <label>Kulcs <select [(ngModel)]="afaSzuro.kulcs"><option value="">mind</option><option *ngFor="let k of [27, 18, 5, 0]" [value]="k">{{ k }}%</option></select></label>
    <input type="search" [(ngModel)]="afaSzuro.kereso" (keydown.enter)="afaSzur()" placeholder="Partner, bizonylatszám, számla…">
    <button type="button" class="ov-gomb fo" (click)="afaSzur()"><ion-icon name="funnel-outline"></ion-icon>Szűrés</button>
    <button type="button" class="ov-gomb" (click)="afaSzuroTorles()">Törlés</button>
  </div>
  <div class="osszeg-sav">
    <div class="item">Fizetendő ÁFA: <b>{{ afa.fizetendo | number:'1.0-0' }} Ft</b></div>
    <div class="item">Levonható ÁFA: <b>{{ afa.levonhato | number:'1.0-0' }} Ft</b></div>
    <div class="item" *ngIf="afa.nem_levonhato">Le nem vonható (fordított, ráfordítás): <b>{{ afa.nem_levonhato | number:'1.0-0' }} Ft</b></div>
    <div class="item">Egyenleg ({{ afa.egyenleg >= 0 ? 'befizetendő' : 'visszaigényelhető' }}): <b>{{ afa.egyenleg | number:'1.0-0' }} Ft</b></div>
  </div>

  <!-- ÁFA-ARÁNYOSÍTÁS (tárgyhó): a le nem vonható előzetes ÁFA T 8693 / K 466 – hó végén, az ÁFA-bevalláskor -->
  <div *ngIf="aranyositasHonap && aranyositas" class="aranyositas-sav" style="margin:10px 0;padding:12px 14px;border:1px solid var(--ion-color-step-200,#e2e8f0);border-radius:10px;background:var(--ion-color-step-50,#f8fafc)">
    <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap">
      <b style="font-size:13.5px">ÁFA-arányosítás – {{ aranyositas.idoszak }} tárgyidőszak</b>
      <span class="halvany" *ngIf="aranyositas.mar_konyvelt" style="color:var(--ion-color-success)">· már könyvelve ({{ aranyositas.bizonylatszam }})</span>
      <span class="spacer" style="flex:1"></span>
      <label style="font-size:12.5px">Vizsgált bevallási sor
        <input type="text" class="kod" style="width:3.5em" [(ngModel)]="aranyositasSor" (change)="aranyositasElonez()"></label>
    </div>
    <div style="display:flex;gap:18px;flex-wrap:wrap;margin-top:8px;font-size:12.5px">
      <span title="Adómentes (adólevonásra NEM jogosító) nettó bevétel, januártól a tárgyidőszak végéig">Mentes nettó (göngyölített): <b>{{ aranyositas.mentes_netto | number:'1.0-0' }} Ft</b></span>
      <span title="Áfás (adólevonásra jogosító) nettó bevétel, januártól a tárgyidőszak végéig">Áfás nettó (göngyölített): <b>{{ aranyositas.afas_netto | number:'1.0-0' }} Ft</b></span>
      <span title="Januártól a tárgyidőszak végéig (göngyölített)">Összes nettó (göngyölített): <b>{{ aranyositas.osszes_netto | number:'1.0-0' }} Ft</b></span>
      <span title="Levonási hányad = áfás ÷ összes bevétel (jan–időszak vége). Nincs mentes bevétel → 1 (minden levonható); nincs áfás → 0.">Levonási hányad: <b>{{ aranyositas.levonasi_hanyad }}</b></span>
      <span title="A tárgyidőszak 68-as sorának áfatartalma">{{ aranyositas.sor }}. sor áfája (tárgyidőszak): <b>{{ aranyositas.afa_68 | number:'1.0-0' }} Ft</b></span>
      <span title="Az arányosítás után levonható marad: levonási hányad × a tárgyidőszak áfája">Levonható (tárgyidőszakra): <b style="color:var(--ion-color-success)">{{ aranyositas.levonhato | number:'1.0-0' }} Ft</b></span>
      <span title="A maradék: (1 − levonási hányad) × a tárgyidőszak áfája">Le nem vonható (tárgyidőszakra): <b style="color:var(--ion-color-danger)">{{ aranyositas.le_nem_vonhato | number:'1.0-0' }} Ft</b></span>
    </div>
    <p class="halvany" style="font-size:11px;margin:4px 2px 0">A levonási hányad januártól a tárgyidőszak végéig göngyölített (áfás ÷ összes nettó bevétel), ezt a tárgyidőszak {{ aranyositas.sor }}-as sorának áfájára vetítjük; a le nem vonható a maradék.</p>
    <div style="margin-top:8px">
      <button type="button" class="ov-gomb fo" [disabled]="aranyositasFut || aranyositas.le_nem_vonhato <= 0" (click)="aranyositasKonyvel()">
        <ion-icon name="calculator-outline"></ion-icon>{{ aranyositas.mar_konyvelt ? 'Arányosítás frissítése' : 'Arányosítás könyvelése' }} (T {{ aranyositas.le_nem_vonhato_szamla }} / K {{ aranyositas.afa_szamla }})
      </button>
      <span class="halvany" style="margin-left:10px;font-size:11.5px">A tárgyhó utolsó napjára, önálló vegyes bizonylatként. A hó végén, az ÁFA-bevallás beadásakor.</span>
    </div>
  </div>
  <table class="naplo-tabla" *ngIf="afa.kulcsok?.length">
    <thead><tr><th>ÁFA-kulcs</th><th class="num">Fizetendő – alap</th><th class="num">Fizetendő – ÁFA</th><th class="num">Levonható – alap</th><th class="num">Levonható – ÁFA</th><th class="num">Tétel</th></tr></thead>
    <tbody><tr *ngFor="let k of afa.kulcsok"><td>{{ k.kulcs === null ? '–' : k.kulcs + '%' }}</td>
      <td class="num">{{ k.fizetendo_alap | number:'1.0-0' }}</td><td class="num">{{ k.fizetendo_afa | number:'1.0-0' }}</td>
      <td class="num">{{ k.levonhato_alap | number:'1.0-0' }}</td><td class="num">{{ k.levonhato_afa | number:'1.0-0' }}</td><td class="num">{{ k.db }}</td></tr></tbody>
  </table>
  <h4 class="afa-cim">Tételek ({{ afa.tetelek?.length || 0 }})</h4>
  <table class="naplo-tabla afa-tetelek">
    <thead><tr><th>ÁFA-dátum</th><th>Bizonylat</th><th>Bizonylatszám</th><th>Partner</th><th>Számla</th><th>Kulcs</th><th>Fajta</th><th>Irány</th><th class="num">Összeg</th><th>Megjegyzés</th></tr></thead>
    <tbody>
      <tr *ngFor="let r of afa.tetelek">
        <td>{{ r.afa_datum }}</td><td>{{ afaNaploJel(r) }}</td><td>{{ r.bizonylatszam }}</td><td>{{ r.partner_nev }}</td><td>{{ r.szamlaszam }}</td>
        <td>{{ r.afa_kulcs === null ? '' : r.afa_kulcs + '%' }}</td><td>{{ r.fajta === 'afa' ? 'ÁFA' : 'alap' }}</td>
        <td>{{ r.irany === 'fizetendo' ? 'fizetendő' : 'levonható' }}</td><td class="num">{{ r.osszeg | number:'1.0-0' }}</td><td class="halvany">{{ r.megjegyzes }}</td>
      </tr>
      <tr *ngIf="!afa.tetelek?.length"><td colspan="10" class="halvany">Nincs a szűrésnek megfelelő ÁFA-tétel.</td></tr>
    </tbody>
  </table>
</div>

<!-- SZÁMLATÜKÖR -->
<div *ngIf="aktiv.ugyfelId && nezet === 'tukor'">
  <div class="naplo-eszkozsor">
    <ion-button size="small" (click)="ujSzla()"><ion-icon slot="start" name="add"></ion-icon>Új számla</ion-button>
    <ion-button size="small" fill="outline" (click)="seedTukor()"><ion-icon slot="start" name="download"></ion-icon>Standard tükör</ion-button>
    <ion-button size="small" fill="outline" (click)="rlbTukorFajl.click()" [disabled]="rlbTukorFut"
                title="Az RLB főkönyvi törzs exportja (foktorzs_*.xls) – a cég saját tükre, alszámlákkal és gyűjtő-jelöléssel">
      <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>{{ rlbTukorFut ? 'Import…' : 'Import RLB-ből' }}</ion-button>
    <input #rlbTukorFajl type="file" accept=".xls,.xlsx,.csv" hidden (change)="rlbTukorImport($any($event.target))">
  </div>
  <div class="tabla-wrap">
    <table class="naplo-tabla">
      <thead><tr><th>Számlaszám</th><th>Megnevezés</th><th>Osztály</th><th>Típus</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let s of tukor" [class.gyujto-sor]="s.gyujto">
          <td><b>{{ s.szamlaszam }}</b></td>
          <td>{{ s.nev }} <ion-badge *ngIf="s.gyujto" color="medium">gyűjtő (nem könyvelhető)</ion-badge></td>
          <td>{{ s.osztaly }}</td><td>{{ s.tipus }}</td>
          <td><ion-buttons>
            <ion-button size="small" (click)="szerkSzla(s)"><ion-icon slot="icon-only" name="create"></ion-icon></ion-button>
            <ion-button size="small" color="danger" (click)="torolSzla(s)"><ion-icon slot="icon-only" name="trash"></ion-icon></ion-button>
          </ion-buttons></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Partner modal -->
<ion-modal #partnerModal class="naplo-wide-modal" (didDismiss)="zarEngedd('zarPartner')">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>{{ partnerSzerk?.id ? 'Partner módosítása' : 'Új partner' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="partnerModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="partnerSzerk">
      <app-szerk-zar-sav [zar]="zarPartner"></app-szerk-zar-sav>
      <ion-item><ion-input label="Név *" labelPlacement="stacked" [(ngModel)]="partnerSzerk.nev"></ion-input></ion-item>
      <ion-item><ion-input label="Adószám" labelPlacement="stacked" [(ngModel)]="partnerSzerk.adoszam"></ion-input></ion-item>
      <ion-item><ion-input label="Közösségi adószám" labelPlacement="stacked" [(ngModel)]="partnerSzerk.kozossegi_adoszam"></ion-input></ion-item>
      <ion-grid><ion-row>
        <ion-col size="4"><ion-item><ion-input label="Irsz." labelPlacement="stacked" [(ngModel)]="partnerSzerk.irsz"></ion-input></ion-item></ion-col>
        <ion-col size="8"><ion-item><ion-input label="Település" labelPlacement="stacked" [(ngModel)]="partnerSzerk.telepules"></ion-input></ion-item></ion-col>
      </ion-row></ion-grid>
      <ion-item><ion-input label="Cím" labelPlacement="stacked" [(ngModel)]="partnerSzerk.cim"></ion-input></ion-item>
      <ion-item><ion-checkbox labelPlacement="end" [(ngModel)]="partnerSzerk.kata">KATA alany</ion-checkbox></ion-item>
      <ion-item><ion-checkbox labelPlacement="end" [(ngModel)]="partnerSzerk.osszesito_nyilatkozat">Összesítő nyilatkozat</ion-checkbox></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" [disabled]="zarTilt(zarPartner)" (click)="mentPartner()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- NYITÁS / ZÁRÁS -->
<!-- ═══ NYITÁS / ZÁRÁS ═══
     Egy folyamat három állomása: az előző év zárása → a tárgyév nyitása → a tárgyév zárása.
     A képernyő ezt lépésként mutatja, mert a sorrend kötött, és a könyvelő ebből látja, hol tart.
     KEZDŐ ÉVBEN nincs mit lezárni: ott a nyitó egyenlegeket kézzel kell felvinni. -->
<div *ngIf="aktiv.ugyfelId && nezet === 'zaras' && zarasAllapot" class="zaras-lap">
  <div class="zaras-fej">
    <div>
      <h3>Nyitás / zárás – {{ zarasAllapot.ev }}</h3>
      <p class="halvany">A nyitó és a záró napló gépi tételek: a kivonat és a mérleg a zárókat nem számolja bele.</p>
    </div>
    <span class="zaras-allapot" [class.kesz]="zarasAllapot.nyitva" [class.zart]="zarasAllapot.zarva">
      {{ zarasAllapot.zarva ? 'lezárt év' : (zarasAllapot.nyitva ? 'megnyitva' : 'nincs megnyitva') }}
    </span>
  </div>

  <div class="zaras-lepesek">
    <!-- 1. lépés: honnan indulunk -->
    <div class="zaras-lepes" [class.kesz]="zarasAllapot.elozo_ev_zarva || zarasAllapot.kezdo_ev">
      <div class="lepes-szam">1</div>
      <div class="lepes-torzs">
        <h4>Előző év ({{ zarasAllapot.ev - 1 }})</h4>
        <p *ngIf="zarasAllapot.kezdo_ev" class="halvany">
          Nincs könyvelés a megelőző évben – ez <b>kezdő év</b>. Nincs mit lezárni: a nyitó egyenlegeket kézzel kell felvinni.
        </p>
        <p *ngIf="!zarasAllapot.kezdo_ev && zarasAllapot.elozo_ev_zarva" class="halvany">
          Le van zárva, a zárómérlegből nyitható a(z) {{ zarasAllapot.ev }}. év.
        </p>
        <p *ngIf="!zarasAllapot.kezdo_ev && !zarasAllapot.elozo_ev_zarva" class="lepes-figyelem">
          <ion-icon name="alert-circle-outline"></ion-icon>
          Nincs lezárva ({{ zarasAllapot.elozo_ev_tetel_db }} könyvelt tétel) – az évnyitáshoz előbb azt kell lezárni.
          Válts át a(z) {{ zarasAllapot.ev - 1 }}. évre, és futtasd le ott az évzárást.
        </p>
      </div>
    </div>

    <!-- 2. lépés: nyitás -->
    <div class="zaras-lepes" [class.kesz]="zarasAllapot.nyitva">
      <div class="lepes-szam">2</div>
      <div class="lepes-torzs">
        <h4>Évnyitás – {{ zarasAllapot.ev }}</h4>
        <p class="halvany">A nyitó tételek a <b>{{ zarasAllapot.nyito_szamla || '491' }}</b> nyitómérleg-számlával szemben keletkeznek.</p>
        <p *ngIf="zarasAllapot.nyitva" class="lepes-kesz"><ion-icon name="checkmark-circle"></ion-icon>
          Megnyitva – {{ zarasAllapot.nyito_tetel_db }} nyitó tétel.</p>
        <div class="lepes-gombok">
          <button type="button" class="ov-gomb fo" *ngIf="!zarasAllapot.nyitva && !zarasAllapot.kezdo_ev"
                  [disabled]="!zarasAllapot.elozo_ev_zarva" (click)="evnyitas()">
            <ion-icon name="lock-open-outline"></ion-icon>Évnyitás a zárómérlegből ({{ zarasAllapot.ev - 1 }} → {{ zarasAllapot.ev }})</button>
          <!-- Kezdő évben ez az egyetlen út: kézi nyitó napló – vagy a korábbi program táblázata. -->
          <button type="button" class="ov-gomb" [class.fo]="zarasAllapot.kezdo_ev" *ngIf="!zarasAllapot.nyitva" (click)="keziNyitoIndit()">
            <ion-icon name="create-outline"></ion-icon>Nyitó egyenlegek kézzel</button>
          <input #nyitoFajlMezo type="file" accept=".xls,.xlsx,.csv" hidden (change)="nyitoFajlValt($event)">
          <button type="button" class="ov-gomb" [disabled]="nyitoFut" (click)="nyitoFajlMezo.click()"
                  title="A korábbi program nyitó napló listája (xls, xlsx vagy csv)">
            <ion-icon name="cloud-upload-outline"></ion-icon>{{ nyitoFut ? 'Beolvasás…' : 'Import táblázatból' }}</button>
          <button type="button" class="ov-gomb" (click)="rlbImportNyit()"
                  title="Az RLB „összes napló” exportja (számlasorosan) – a teljes év könyvelése, a nyitótételekkel együtt">
            <ion-icon name="cloud-upload-outline"></ion-icon>RLB-import</button>
          <button type="button" class="ov-gomb" *ngIf="zarasAllapot.nyitva" (click)="nyitasVisszavon()">
            <ion-icon name="arrow-undo-outline"></ion-icon>Nyitás visszavonása</button>
        </div>
      </div>
    </div>

    <!-- 3. lépés: zárás -->
    <div class="zaras-lepes" [class.kesz]="zarasAllapot.zarva">
      <div class="lepes-szam">3</div>
      <div class="lepes-torzs">
        <h4>Évzárás – {{ zarasAllapot.ev }}</h4>
        <p class="halvany">Eredményszámlák → eredményelszámolás (493), mérlegszámlák → zárómérleg (492).</p>
        <p *ngIf="zarasAllapot.zarva" class="lepes-kesz"><ion-icon name="checkmark-circle"></ion-icon>
          Lezárva – {{ zarasAllapot.zaro_tetel_db }} záró tétel.</p>
        <div class="lepes-gombok">
          <button type="button" class="ov-gomb zaro" *ngIf="!zarasAllapot.zarva" (click)="evzaras()">
            <ion-icon name="lock-closed-outline"></ion-icon>Évzárás</button>
          <button type="button" class="ov-gomb" *ngIf="zarasAllapot.zarva" (click)="zarasVisszavon()">
            <ion-icon name="arrow-undo-outline"></ion-icon>Zárás visszavonása</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- BEÁLLÍTÁSOK – szekciókba rendezett, kártyás elrendezés. A mezők (ngModel-kulcsok) és a
     mentő logika (mentBeallitas) változatlanok, csak a megjelenítés lett letisztultabb. -->
<div class="beall" *ngIf="aktiv.ugyfelId && nezet === 'beallitas' && beallitas">
  <div class="beall-fej">
    <h2>Könyvelési beállítások</h2>
    <p>Az automatikus kontírozás és az évnyitás/évzárás alapértelmezett főkönyvi számai. A mentés azonnal életbe lép, kódkiadás nélkül.</p>
  </div>

  <!-- 1. A kontírozó alapértelmezett ellenszámlái -->
  <ion-card class="naplo-card beall-kartya">
    <ion-card-header>
      <ion-card-title>Alapértelmezett ellenszámlák</ion-card-title>
      <ion-card-subtitle>Ezeket írja be a kontírozó automatikusan, a napló típusa szerint (pl. belföldi szállító 4541).</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="beall-racs">
        <ion-item><ion-input label="Szállító számla" labelPlacement="stacked" placeholder="4541" helperText="Belföldi szállítók kötelezettsége" [(ngModel)]="beallitas.szallito_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Vevő számla" labelPlacement="stacked" placeholder="311" helperText="Belföldi vevők követelése" [(ngModel)]="beallitas.vevo_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Pénztár számla" labelPlacement="stacked" placeholder="381" helperText="Készpénzes tételek ellenszámlája" [(ngModel)]="beallitas.penztar_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Bank számla" labelPlacement="stacked" placeholder="384" helperText="Banki tételek ellenszámlája" [(ngModel)]="beallitas.bank_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Előzetes (levonható) ÁFA" labelPlacement="stacked" placeholder="466" helperText="Beszerzés levonható ÁFA-ja" [(ngModel)]="beallitas.afa_elozetes"></ion-input></ion-item>
        <ion-item><ion-input label="Fizetendő ÁFA" labelPlacement="stacked" placeholder="467" helperText="Értékesítés fizetendő ÁFA-ja" [(ngModel)]="beallitas.afa_fizetendo"></ion-input></ion-item>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- 2. Devizás tétel partnerszámlái + fordított ÁFA -->
  <ion-card class="naplo-card beall-kartya">
    <ion-card-header>
      <ion-card-title>Devizás tételek és fordított ÁFA</ion-card-title>
      <ion-card-subtitle>Devizás bizonylatnál ezek lépnek a forintos partnerszámlák helyére; üresen a forintos számla marad érvényben.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="beall-racs">
        <ion-item><ion-input label="Devizás vevő számla" labelPlacement="stacked" placeholder="317" helperText="Üresen a forintos vevőszámlát használja" [(ngModel)]="beallitas.deviza_vevo_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Devizás szállító számla" labelPlacement="stacked" placeholder="4542" helperText="Üresen a forintos szállítószámlát használja" [(ngModel)]="beallitas.deviza_szallito_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Fordított ÁFA ráfordítás-számla" labelPlacement="stacked" placeholder="8671" helperText="Nem áfaalany cégnél a fordított adó ráfordítása (8. számlaosztály)" [(ngModel)]="beallitas.forditott_afa_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Adott előleg számla" labelPlacement="stacked" placeholder="383" helperText="Az „Előleg” jelölős bizonylat: T ez / K bank, bruttóban; végszámlánál T szállító / K ez" [(ngModel)]="beallitas.eloleg_adott_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Adott előleg ÁFA-számla" labelPlacement="stacked" placeholder="3572" helperText="Az előleg ÁFA-ja: T 466 / K ez; végszámlánál T ez / K 466 (ÁFA-mentes cégnél nincs)" [(ngModel)]="beallitas.eloleg_afa_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Kapott előleg számla" labelPlacement="stacked" placeholder="453" helperText="Kapott előleg: T bank / K ez, bruttóban; végszámlánál T ez / K vevő" [(ngModel)]="beallitas.eloleg_kapott_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Kapott előleg ÁFA-számla" labelPlacement="stacked" placeholder="3571" helperText="A kapott előleg ÁFA-ja: T ez / K 467; végszámlánál T 467 / K ez (ÁFA-mentes cégnél nincs)" [(ngModel)]="beallitas.eloleg_kapott_afa_szamla"></ion-input></ion-item>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- 3. Évnyitás / évzárás technikai számlái -->
  <ion-card class="naplo-card beall-kartya">
    <ion-card-header>
      <ion-card-title>Évnyitás és évzárás</ion-card-title>
      <ion-card-subtitle>A zárás-nyitás technikai számlái. Üres mezőnél az adott automatikus átvezetés kimarad.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="beall-racs">
        <ion-item><ion-input label="Nyitómérleg számla" labelPlacement="stacked" placeholder="491" helperText="Évnyitás technikai számlája" [(ngModel)]="beallitas.nyito_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Zárómérleg számla" labelPlacement="stacked" placeholder="492" helperText="Évzárás technikai számlája" [(ngModel)]="beallitas.zaro_merleg_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Eredményszámlák zárása" labelPlacement="stacked" placeholder="493" helperText="Adózott eredmény elszámolása" [(ngModel)]="beallitas.eredmeny_zaras_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Mérleg szerinti eredmény" labelPlacement="stacked" placeholder="419" helperText="Üresen nincs automatikus átvezetés" [(ngModel)]="beallitas.adozott_eredmeny_szamla"></ion-input></ion-item>
        <ion-item><ion-input label="Eredménytartalék" labelPlacement="stacked" placeholder="413" helperText="Nyitás után ide vezetjük át az előző évi eredményt" [(ngModel)]="beallitas.eredmenytartalek_szamla"></ion-input></ion-item>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- 4. Sorszámozás -->
  <ion-card class="naplo-card beall-kartya">
    <ion-card-header>
      <ion-card-title>Sorszámozás</ion-card-title>
      <ion-card-subtitle>A bizonylatok naplón belüli sorszámának kezelése.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-item lines="none" class="beall-toggle">
        <ion-toggle [(ngModel)]="beallitas.auto_sorszam" [ngModelOptions]="{ standalone: true }" justify="start" labelPlacement="end">
          Automatikus újraszámozás dátum szerint
        </ion-toggle>
      </ion-item>
      <ion-note class="beall-sugo">Közbekönyveléskor a későbbi bizonylatok sorszáma eggyel hátrébb csúszik. Kikapcsolva a sorszám marad, az új tétel a napló végére kerül; a Naplók „Újraszámozás” gombja ettől függetlenül működik.</ion-note>
    </ion-card-content>
  </ion-card>

  <div class="beall-lab">
    <ion-button (click)="mentBeallitas()"><ion-icon slot="start" name="save-outline"></ion-icon>Beállítások mentése</ion-button>
  </div>
</div>

<!-- Főkönyvi karton (a kivonat sorára kattintva) -->
<ion-modal [isOpen]="!!karton" (didDismiss)="kartonZar()" class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>Főkönyvi karton – {{ karton?.szamla }} {{ karton?.nev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="kartonZar()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="karton">
      <div class="tabla-wrap">
        <table class="naplo-tabla">
          <thead><tr><th>Dátum</th><th>Bizonylat</th><th>Megnevezés</th><th>Partner</th><th class="num">Tartozik</th><th class="num">Követel</th><th class="num">Egyenleg</th></tr></thead>
          <tbody>
            <tr *ngFor="let s of karton.sorok">
              <td>{{ s.datum | date:'yyyy.MM.dd' }}</td><td>{{ s.bizonylatszam }}</td><td>{{ s.megnevezes }}</td><td>{{ s.partner_nev }}</td>
              <td class="num">{{ s.tartozik | number:'1.0-0' }}</td><td class="num">{{ s.kovetel | number:'1.0-0' }}</td>
              <td class="num"><b>{{ s.egyenleg | number:'1.0-0' }}</b></td>
            </tr>
          </tbody>
        </table>
        <div class="ures" *ngIf="!karton.sorok.length"><ion-icon name="document"></ion-icon>Nincs tétel ezen a számlán.</div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Főkönyvi szám választó a törzsből (számlatükör) -->
<ion-modal #szlaValaszto class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>Főkönyvi szám választása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szlaValaszto.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <ion-searchbar placeholder="Keresés szám vagy név szerint…" [(ngModel)]="szlaKereso" debounce="120"></ion-searchbar>
      <div *ngIf="!szlaTalalat.length" class="ures">Nincs találat.</div>
      <table class="naplo-tabla" *ngIf="szlaTalalat.length">
        <thead><tr><th>Szám</th><th>Megnevezés</th><th>Típus</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let x of szlaTalalat">
            <td><b>{{ x.szamlaszam }}</b></td><td>{{ x.nev }}</td><td class="halvany">{{ x.tipus }}</td>
            <td class="jobb"><ion-button size="small" (click)="valasztSzla(x)"><ion-icon slot="start" name="checkmark"></ion-icon>Választ</ion-button></td>
          </tr>
        </tbody>
      </table>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Kereshető partner-választó (a bizonylat fejlécéhez) -->
<ion-modal #partnerPicker class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>Partner kiválasztása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="partnerPicker.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <ion-searchbar placeholder="Keresés név vagy adószám szerint…" [(ngModel)]="partnerKereso" [debounce]="150"></ion-searchbar>
      <ion-list>
        <ion-item button *ngFor="let p of szurtPartnerek" (click)="partnerValaszt(p)">
          <ion-label>
            <h3>{{ p.rovid_nev || p.nev }}</h3>
            <p *ngIf="p.rovid_nev && p.nev !== p.rovid_nev">{{ p.nev }}</p>
            <p *ngIf="p.adoszam">Adószám: {{ p.adoszam }}</p>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!szurtPartnerek.length" lines="none"><ion-label color="medium">Nincs találat.</ion-label></ion-item>
      </ion-list>
      <div class="ion-padding" *ngIf="partnerKereso.trim()">
        <ion-button expand="block" fill="outline" (click)="partnerLetrehozKeresobol()">
          <ion-icon slot="start" name="add"></ion-icon> Új partner: „{{ partnerKereso }}"
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Számla (számlatükör) modal -->
<ion-modal #szlaModal (didDismiss)="zarEngedd('zarSzla')">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff"><ion-title>{{ szlaSzerk?.id ? 'Számla' : 'Új számla' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szlaModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szlaSzerk">
      <app-szerk-zar-sav [zar]="zarSzla"></app-szerk-zar-sav>
      <ion-item><ion-input label="Számlaszám *" labelPlacement="stacked" [(ngModel)]="szlaSzerk.szamlaszam" placeholder="pl. 4541"></ion-input></ion-item>
      <ion-item><ion-input label="Megnevezés *" labelPlacement="stacked" [(ngModel)]="szlaSzerk.nev"></ion-input></ion-item>
      <ion-item><ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="szlaSzerk.tipus" interface="popover">
        <ion-select-option value="eszkoz">Eszköz</ion-select-option><ion-select-option value="forras">Forrás</ion-select-option>
        <ion-select-option value="koltseg">Költség</ion-select-option><ion-select-option value="raforditas">Ráfordítás</ion-select-option>
        <ion-select-option value="bevetel">Bevétel</ion-select-option></ion-select></ion-item>
      <ion-item><ion-input type="number" label="Jellemző ÁFA-kulcs (%)" labelPlacement="stacked" [(ngModel)]="szlaSzerk.afa_kulcs"></ion-input></ion-item>
      <ion-item><ion-toggle [(ngModel)]="szlaSzerk.gyujto" labelPlacement="end">Gyűjtő számla (nem könyvelhető, csak összesít)</ion-toggle></ion-item>
      <ion-item><ion-toggle [(ngModel)]="szlaSzerk.penzszamla" labelPlacement="end">Pénztár/bank számla</ion-toggle></ion-item>
      <ion-item><ion-toggle [(ngModel)]="szlaSzerk.aktiv" labelPlacement="end">Aktív</ion-toggle></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" [disabled]="zarTilt(zarSzla)" (click)="mentSzla()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- ═══ SZÁMLASOR RÖGZÍTÉSE (RLB mintájára) ═══ -->
<ion-modal [isOpen]="!!sorAblak" (didDismiss)="sorAblak = null" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Számlasor rögzítése</ion-title></ion-toolbar></ion-header>
    <!-- Tartalomhoz méretezett ablak: sima div (ion-content auto magasságnál nem méreteződik). -->
    <div class="sa-torzs">
      <div class="sa" *ngIf="sorAblak" (keydown.enter)="$event.preventDefault(); sorAblakMent()">
        <label class="kv-mezo sa-megj"><span>Megjegyzés</span><input type="text" [(ngModel)]="sorAblak.megj" autofocus></label>
        <label class="kv-mezo"><span>Munkaszám</span>
          <span class="sa-bev">
            <input type="text" class="kod" [(ngModel)]="sorAblak.munkaszam" list="kvMszLista" maxlength="10" style="width:120px">
            <small class="halvany">{{ munkaszamNev(sorAblak.munkaszam) || (szerk?.munkaszam && sorAblak.munkaszam !== szerk.munkaszam ? 'a fejlécben: ' + szerk.munkaszam : '') }}</small>
          </span></label>

        <div class="sa-jelolok">
          <label [title]="afasTetelLehet ? '' : 'A cég nem áfaalany – a tétel bruttóban könyvelődik.'">
            <input type="checkbox" [(ngModel)]="sorAblak.afas" (ngModelChange)="sorAblakAfasValt()"
                   [disabled]="sorAblak.fordit || !afasTetelLehet"> ÁFÁ-s tétel</label>
          <!-- Fordított adózás CSAK szállítói számlán: a számlán nincs ÁFA, azt a vevő önadózza. -->
          <label *ngIf="forditLehet"><input type="checkbox" [(ngModel)]="sorAblak.fordit" (ngModelChange)="sorAblakForditValt()"> Fordított ÁFÁ-s tétel</label>
          <label><input type="checkbox" [ngModel]="sorAblak.osszesito === 'termek'" (ngModelChange)="sorAblakOsszesito('termek', $event)"> Összesítő nyilatkozat (termék)</label>
          <label><input type="checkbox" [ngModel]="sorAblak.osszesito === 'szolgaltatas'" (ngModelChange)="sorAblakOsszesito('szolgaltatas', $event)"> Összesítő nyilatkozat (szolgáltatás)</label>
        </div>

        <div class="sa-doboz">
          <label class="kv-mezo"><span>ÁFA %</span>
            <select [(ngModel)]="sorAblak.afa_v" (ngModelChange)="afaValt(sorAblak)" [disabled]="!sorAblak.afas || !afasTetelLehet">
              <option *ngFor="let a of afaValasztek" [value]="a.v">{{ a.c }}</option>
            </select></label>
          <label class="kv-mezo"><span>Bev. sor</span>
            <span class="sa-bev">
              <input type="text" class="kod" [(ngModel)]="sorAblak.bev_sor" (ngModelChange)="bevSorAdokod(sorAblak)" list="bevSorLista" placeholder="sor" [disabled]="!bevSorLehet(sorAblak)">
              <datalist id="bevSorLista"><option *ngFor="let b of bevallasSorok" [value]="b">{{ bevsorNev(b) }}</option></datalist>
              <button type="button" class="kv-mini" [disabled]="!bevSorLehet(sorAblak)" (click)="bevsorNyit(sorAblak, 'bev_sor')" title="Bevallási sor kiválasztása a törzsből"><ion-icon name="list-outline"></ion-icon></button>
              <span class="bevsor-tanult" *ngIf="bevTanultLatszik(sorAblak)" [title]="bevTanultCim(sorAblak)">tanult</span>
              <small class="halvany">{{ bevsorNev(sorAblak.bev_sor) }}</small>
            </span></label>
          <label class="kv-mezo"><span>Adókód</span>
            <span class="sa-bev">
              <input type="text" class="kod" [(ngModel)]="sorAblak.adokod" (ngModelChange)="adokodBeirva(sorAblak)" list="adokodLista" placeholder="pl. MD66" [disabled]="!bevSorLehet(sorAblak)">
              <datalist id="adokodLista"><option *ngFor="let a of adokodok" [value]="a.kod">{{ a.beszedes }} – {{ a.nev }}</option></datalist>
              <button type="button" class="kv-mini" [disabled]="!bevSorLehet(sorAblak)" (click)="adokodNyit(sorAblak)" title="Választás a NAV szabványos adókódjai közül (az oldal és az ÁFA szerint szűrve)"><ion-icon name="list-outline"></ion-icon></button>
              <small class="halvany" [class.gepi]="sorAblak.adokod && sorAblak.adokod === sorAblak._adokodAuto"
                     [title]="sorAblak.adokod && sorAblak.adokod === sorAblak._adokodAuto ? 'Az ÁFA-választás alapján, gépi – átírható' : ''">{{ adokodNev(sorAblak.adokod) }}</small>
            </span></label>
          <!-- Levonható hányad (Áfa tv. 123–124. §): csak áfás beszerzésnél. A le nem vonható rész a költségre kerül. -->
          <label class="kv-mezo" *ngIf="levonhatoLehet(sorAblak)" title="Pl. telefon: 70 (a 30% nem vonható le). 0 = egyáltalán nem vonható le (KL V00).">
            <span>Levonható %</span>
            <span class="sa-bev">
              <input type="number" class="kod" min="0" max="100" step="1" [(ngModel)]="sorAblak.levonhato" (ngModelChange)="levonhatoValt(sorAblak)" placeholder="100">
              <small class="halvany" *ngIf="sorAblak.levonhato !== '' && sorAblak.levonhato != null && +sorAblak.levonhato < 100">
                levonható ÁFA: {{ ((+sorAblak.afa || 0) * (+sorAblak.levonhato || 0) / 100) | number:'1.0-2' }} · a többi költség</small>
            </span></label>
          <p class="halvany sa-sugo" *ngIf="!afasTetelLehet">
            A cég <b>nem áfaalany</b>: a tétel <b>bruttóban</b> kerül a költségre (nincs levonható ÁFA), ezért az
            ÁFÁ-s tétel nem jelölhető. <b>Fordított adózású</b> tétel viszont igen – ott az adót akkor is önadózni kell,
            csak nem levonható, hanem ráfordítás.
          </p>
          <!--  A fordított adózás nem csak belföldi lehet: a jogcím dönti el a bevallási sort,
                az összesítő nyilatkozatot és azt, hogy kell-e közösségi adószám. -->
          <label class="kv-mezo" *ngIf="sorAblak.fordit"><span>Jogcím</span>
            <select [(ngModel)]="sorAblak.fordit_jogcim" (ngModelChange)="sorAblakJogcimValt()">
              <option *ngFor="let j of forditJogcimek" [value]="j.v">{{ j.c }}</option>
            </select></label>
          <p class="sa-sugo" *ngIf="forditEuHiany" style="color:#b45309">
            <ion-icon name="warning-outline"></ion-icon>
            Közösségen belüli ügylethez a partner <b>közösségi adószáma</b> kell (összesítő nyilatkozat).
            A partnernél nem látok ilyet – ha a partner nem uniós, válaszd a <b>harmadik országbeli</b> jogcímet.
          </p>
          <p class="halvany sa-sugo" *ngIf="sorAblak.fordit || sorAblak.afa_kod === 'FAD'">
            Fordított adózás: a számlán nincs ÁFA. A fizetendő és a levonható ÁFA önálló (vegyes) bizonylatra kerül –
            a bizonylat mentése után a rendszer rákérdez. Gabona- és acélipari termékeknél a <b>tételes nyilatkozat</b> is kell.
          </p>
        </div>

        <div class="sa-doboz sa-osszegek">
          <label class="kv-mezo"><span>{{ afasTetelLehet ? 'Nettó' : 'Összeg (bruttó)' }}</span>
            <input type="number" step="0.01" [(ngModel)]="sorAblak.netto" (blur)="szamlasorSzamol(sorAblak, 'netto')"></label>
          <span class="sa-fok"><span>Fők.sz.</span>
            <input class="kod" type="text" [(ngModel)]="sorAblak.fok" (ngModelChange)="adokodAuto(sorAblak)" list="szlaLista" [placeholder]="szerk?.naplo_tipus === 'vevo' ? '911' : '511'">
            <button type="button" class="sa-tk" (click)="oldalValt(sorAblak)" title="Tartozik / Követel">{{ sorAblak.oldal || alapSorOldal() }}</button>
            <button type="button" class="kv-mini" (click)="nyitSzlaValaszto({ szamlasor: sorAblak })" title="Választás a számlatükörből"><ion-icon name="list-outline"></ion-icon></button>
            <small class="halvany">{{ szamlaNev(sorAblak.fok) }}</small></span>

          <label class="kv-mezo"><span>ÁFA</span><input type="number" step="0.01" [(ngModel)]="sorAblak.afa" [disabled]="!sorAblak.afas || !afasTetelLehet" (ngModelChange)="sorAblak.brutto = (+sorAblak.netto || 0) + (+sorAblak.afa || 0)"></label>
          <span class="sa-fok"><span>Fők.sz.</span>
            <input class="kod" type="text" [(ngModel)]="sorAblak.afa_szla" list="szlaLista" [placeholder]="afaAlapSzla()" [disabled]="!sorAblak.afas">
            <span class="sa-tk ro">{{ sorAblak.oldal || alapSorOldal() }}</span>
            <small class="halvany">{{ szamlaNev(sorAblak.afa_szla || afaAlapSzla()) }}</small></span>

          <label class="kv-mezo"><span>Bruttó</span><input type="number" step="0.01" [(ngModel)]="sorAblak.brutto" (blur)="szamlasorSzamol(sorAblak, 'brutto')"></label>
          <span class="sa-fok"><span>Fők.sz.</span>
            <input class="kod" type="text" [value]="szerk?.foszamla || ''" readonly title="A bizonylat fő számlája (a partner-láb) – a fejlécben állítható">
            <span class="sa-tk ro">{{ (sorAblak.oldal || alapSorOldal()) === 'T' ? 'K' : 'T' }}</span>
            <small class="halvany">{{ szamlaNev(szerk?.foszamla) }}</small></span>
        </div>

        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" (click)="sorAblakMent()"><ion-icon name="checkmark"></ion-icon>Mentés</button>
          <!-- Áfa tv. 6/A–6/B. melléklet: gabona / acélipari termék – termékenkénti nyilatkozat (2026-ig teljesített ügyletre) -->
          <button type="button" class="ov-gomb" *ngIf="sorAblak.fordit && tetelesForditottElerheto" (click)="forditTetelNyit()"
                  title="Tételes fordított adózású nyilatkozat (vámtarifaszám, mennyiség, adóalap) – a sor mentésével együtt">
            <ion-icon name="list-outline"></ion-icon>Tételes ford. ÁFA + Mentés</button>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" (click)="sorAblak = null">Kilépés</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ BEVALLÁSI SOR KIVÁLASZTÁSA (törzsből, mint a főkönyvi szám) ═══ -->
<ion-modal [isOpen]="!!bevsorCel" (didDismiss)="bevsorCel = null" cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Bevallási sor kiválasztása</ion-title></ion-toolbar></ion-header>
    <div class="bv-torzs">
      <app-naplo-bevsor-valaszto [aktualis]="bevsorCel ? bevsorCel.obj[bevsorCel.mezo] : null"
        (valaszt)="bevsorValaszt($event)" (megse)="bevsorCel = null"></app-naplo-bevsor-valaszto>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ TÉTELES FORDÍTOTT ADÓZÁSÚ TÉTEL (Áfa tv. 6/A–6/B. melléklet) ═══ -->
<ion-modal [isOpen]="!!forditTetelAblak" (didDismiss)="forditTetelAblak = null" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Fordított adózású tételek</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="forditTetelAblak">
        <label class="kv-mezo"><span>Értékesítés/beszerzés</span>
          <select [(ngModel)]="forditTetelAblak.irany">
            <option value="beszerzes">Beszerzés</option><option value="ertekesites">Értékesítés</option>
          </select></label>
        <label class="kv-mezo"><span>Bevallás dátuma</span><input type="date" [(ngModel)]="forditTetelAblak.bevallas_datum"></label>
        <label class="kv-mezo"><span>Teljesítés dátuma</span><input type="date" [(ngModel)]="forditTetelAblak.teljesites"></label>
        <label class="kv-mezo"><span>Bizonylatszám</span><input type="text" [(ngModel)]="forditTetelAblak.bizonylatszam"></label>
        <label class="kv-mezo"><span>Partner</span><input type="text" [(ngModel)]="forditTetelAblak.partner_nev"></label>
        <label class="kv-mezo"><span>Adószám</span><input type="text" [(ngModel)]="forditTetelAblak.adoszam"></label>
        <label class="kv-mezo"><span>Termék</span>
          <select [(ngModel)]="forditTetelAblak.vtsz" (ngModelChange)="forditTermekValt()">
            <option value="">– válassz –</option>
            <option *ngFor="let t of forditTermekek" [value]="t.vtsz">{{ t.vtsz }} – {{ t.nev }}</option>
          </select></label>
        <label class="kv-mezo"><span>Vámtarifaszám</span><input type="text" [(ngModel)]="forditTetelAblak.vtsz" readonly></label>
        <label class="kv-mezo"><span>Termék megnevezése</span><input type="text" [(ngModel)]="forditTetelAblak.termek_nev"></label>
        <div class="sa-doboz sa-osszegek">
          <label class="kv-mezo"><span>Mennyiség ({{ forditTermekMe }})</span><input type="number" step="1" [(ngModel)]="forditTetelAblak.mennyiseg" [disabled]="forditTetelAblak.mennyiseg_nelkul"></label>
          <label style="display:inline-flex;align-items:center;gap:6px">
            <input type="checkbox" [(ngModel)]="forditTetelAblak.mennyiseg_nelkul"> Hibrid vetőmag (mennyiség nélkül)</label>
          <label class="kv-mezo"><span>Adóalap</span><input type="number" step="0.01" [(ngModel)]="forditTetelAblak.adoalap"></label>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" (click)="forditTetelMent()"><ion-icon name="checkmark"></ion-icon>Mentés</button>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" (click)="forditTetelAblak = null">Mégsem</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ FORDÍTOTT ÁFA KÖNYVELÉSE (a bizonylat mentése után) ═══ -->
<!-- Tárgyi eszköz felvétele a szállítói számlából (161 / 11–14) -->
<ion-modal [isOpen]="!!eszkozFelvetel" (didDismiss)="eszkozFelvetel && eszkozFelvetelZar()" cssClass="sorablak-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Tárgyi eszköz felvétele</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="eszkozFelvetel">
        <p class="sa-sugo">A számla beruházás / tárgyi eszköz számlára ment. Felvegyük a Tárgyi eszköz nyilvántartásba is?
          A <b>161</b>-es tétel <b>beruházás</b> marad (écs nélkül), amíg meg nem adod az aktiválás napját – ha most megadod,
          az aktiválás is lekönyvelődik (T 13x / K 161).</p>
        <div class="tabla-wrap">
          <table class="n-racs">
            <thead><tr><th></th><th>Számla</th><th>Megnevezés</th><th>Csoport</th><th class="num">Bekerülési érték</th>
              <th>Beszerzés</th><th>Aktiválás</th><th>Écs</th><th>Leltári sz.</th></tr></thead>
            <tbody>
              <tr *ngFor="let x of eszkozFelvetel.sorok">
                <td><input type="checkbox" [(ngModel)]="x.jelol"></td>
                <td><b>{{ x.szamla }}</b><div class="halvany" *ngIf="x.beruhazas">→ {{ x.fokonyvi_szamla }}</div></td>
                <td><input type="text" [(ngModel)]="x.megnevezes" [disabled]="!x.jelol" style="min-width:180px"></td>
                <td><select [(ngModel)]="x.csoport" (ngModelChange)="eszkozFelvetelCsoport(x)" [disabled]="!x.jelol">
                  <option *ngFor="let c of eszkozFelvetel.csoportok" [value]="c.kulcs">{{ c.nev }}</option></select></td>
                <td class="num">{{ x.brutto_ertek | number:'1.0-2' }}</td>
                <td><input type="date" max="9999-12-31" [(ngModel)]="x.beszerzes_datum" [disabled]="!x.jelol"></td>
                <td><input type="date" max="9999-12-31" [(ngModel)]="x.aktivalas_datum" [disabled]="!x.jelol"
                           [title]="x.beruhazas ? 'Üresen: beruházás marad, később aktiválható' : 'Használatbavétel – innen számol az écs'"></td>
                <td><select [(ngModel)]="x.ecs_mod" [disabled]="!x.jelol">
                  <option value="linearis">{{ x.ecs_kulcs }}% évente</option>
                  <option value="azonnali">egy összegben</option>
                  <option value="nincs">nem écs.</option></select></td>
                <td><input type="text" [(ngModel)]="x.leltari_szam" maxlength="40" [disabled]="!x.jelol" style="width:90px"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" (click)="eszkozFelvetelMent()"><ion-icon name="add"></ion-icon>Felvétel</button>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" (click)="eszkozFelvetelZar()">Most nem</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="!!forditAblak" (didDismiss)="forditAblak = null" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Fordított ÁFA könyvelése</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="forditAblak">
        <div class="sa-doboz sa-osszegek">
          <label class="kv-mezo" style="grid-column:1/-1"><span>Jogcím</span>
            <select [(ngModel)]="forditAblak.jogcim" (ngModelChange)="forditKulcsValt()">
              <option *ngFor="let j of forditJogcimek" [value]="j.v">{{ j.c }}</option>
            </select></label>
          <label class="kv-mezo"><span>Adóalap</span>
            <input type="number" step="0.01" [(ngModel)]="forditAblak.alap" (blur)="forditElonezetFrissit()"></label>
          <label class="kv-mezo"><span>ÁFA %</span>
            <select [(ngModel)]="forditAblak.kulcs" (ngModelChange)="forditKulcsValt()">
              <option [ngValue]="27">27%</option><option [ngValue]="18">18%</option><option [ngValue]="5">5%</option>
            </select></label>
          <span class="halvany">ÁFA: <b>{{ forditAblak.afa || 0 | number:'1.0-0' }}</b> · bruttó: {{ forditAblak.brutto || 0 | number:'1.0-0' }}</span>
        </div>

        <!-- FIZETENDŐ oldal -->
        <div class="sa-doboz">
          <b>Fizetendő ÁFA könyvelése</b>
          <label class="kv-mezo"><span>Dátum</span><input type="date" [(ngModel)]="forditAblak.fizetendo.datum"></label>
          <label class="kv-mezo"><span>Bizonylatsz.</span><input type="text" [(ngModel)]="forditAblak.fizetendo.bizonylatszam"></label>
          <label class="kv-mezo"><span>Munkaszám</span><input type="text" [(ngModel)]="forditAblak.fizetendo.munkaszam"></label>
          <label class="kv-mezo"><span>Partner</span><input type="text" [(ngModel)]="forditAblak.fizetendo.partner_nev"></label>
          <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="forditAblak.fizetendo.megjegyzes"></label>
          <label class="kv-mezo"><span>Bev. sor</span><input type="text" class="kod" [(ngModel)]="forditAblak.fizetendo.bev_sor" (ngModelChange)="bevSorAdokod(forditAblak.fizetendo)" list="bevSorLista"></label>
          <label class="kv-mezo"><span>Adókód</span>
            <span class="sa-bev">
              <input type="text" class="kod" [(ngModel)]="forditAblak.fizetendo.adokod" (ngModelChange)="adokodBeirva(forditAblak.fizetendo)" list="adokodLista">
              <button type="button" class="kv-mini" (click)="adokodNyit(forditAblak.fizetendo)" title="Választás az adókód-törzsből"><ion-icon name="list-outline"></ion-icon></button>
              <small class="halvany">{{ adokodNev(forditAblak.fizetendo.adokod) }}</small>
            </span></label>
          <label class="kv-mezo"><span>ÁFA főkönyv</span><input type="text" class="kod" [(ngModel)]="forditAblak.fizetendo.afa_szla" (blur)="forditElonezetFrissit()" list="szlaLista"></label>
        </div>

        <!-- LEVONHATÓ oldal – csak áfaalanynál; alanyi adómentes ügyfélnek nincs levonási joga -->
        <p class="sa-sugo" *ngIf="!ugyfelAfas">
          <ion-icon name="information-circle-outline"></ion-icon>
          Az ügyfél <b>alanyi adómentes</b>: levonási joga nincs, ezért levonható ÁFA nem könyvelődik – a fizetendő adó
          <b>ráfordítás</b> (T a beállított ráfordítás-számla, alapból 8671 / K fizetendő ÁFA).</p>
        <div class="sa-doboz" *ngIf="ugyfelAfas">
          <b>Levonható ÁFA könyvelése</b>
          <label class="kv-mezo"><span>Dátum</span><input type="date" [(ngModel)]="forditAblak.levonhato.datum"></label>
          <label class="kv-mezo"><span>Bizonylatsz.</span><input type="text" [(ngModel)]="forditAblak.levonhato.bizonylatszam"></label>
          <label class="kv-mezo"><span>Munkaszám</span><input type="text" [(ngModel)]="forditAblak.levonhato.munkaszam"></label>
          <label class="kv-mezo"><span>Partner</span><input type="text" [(ngModel)]="forditAblak.levonhato.partner_nev"></label>
          <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="forditAblak.levonhato.megjegyzes"></label>
          <label class="kv-mezo"><span>Bev. sor</span><input type="text" class="kod" [(ngModel)]="forditAblak.levonhato.bev_sor" (ngModelChange)="bevSorAdokod(forditAblak.levonhato)" list="bevSorLista"></label>
          <label class="kv-mezo"><span>Adókód</span>
            <span class="sa-bev">
              <input type="text" class="kod" [(ngModel)]="forditAblak.levonhato.adokod" (ngModelChange)="adokodBeirva(forditAblak.levonhato)" list="adokodLista">
              <button type="button" class="kv-mini" (click)="adokodNyit(forditAblak.levonhato)" title="Választás az adókód-törzsből"><ion-icon name="list-outline"></ion-icon></button>
              <small class="halvany">{{ adokodNev(forditAblak.levonhato.adokod) }}</small>
            </span></label>
          <label class="kv-mezo"><span>ÁFA főkönyv</span><input type="text" class="kod" [(ngModel)]="forditAblak.levonhato.afa_szla" (blur)="forditElonezetFrissit()" list="szlaLista"></label>
        </div>

        <label style="display:inline-flex;align-items:center;gap:6px;margin:4px 0">
          <input type="checkbox" [(ngModel)]="forditAblak.csak_afa" (ngModelChange)="forditElonezetFrissit()">
          Csak az ÁFA könyvelése (alap nélkül)</label>

        <!-- Mi fog könyvelődni: a könyvelő lássa, mielőtt rábólint -->
        <div class="tabla-wrap" *ngIf="forditElonezet.length">
          <table class="n-racs">
            <thead><tr><th>Főkönyv</th><th>Megjegyzés</th><th class="num">Tartozik</th><th class="num">Követel</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of forditElonezet">
                <td><b>{{ s.szamlaszam }}</b> <small class="halvany">{{ szamlaNev(s.szamlaszam) }}</small></td>
                <td>{{ s.megjegyzes }}</td>
                <td class="num">{{ s.tartozik ? (s.tartozik | number:'1.0-2') : '' }}</td>
                <td class="num">{{ s.kovetel ? (s.kovetel | number:'1.0-2') : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" [disabled]="!forditElonezet.length" (click)="forditAblakMent()">
            <ion-icon name="checkmark"></ion-icon>Mentés</button>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" (click)="forditAblak = null">Mégsem</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ ADÓKÓD KIVÁLASZTÁSA (a törzsből, mint a főkönyvi szám) ═══ -->
<ion-modal [isOpen]="!!adokodCel" (didDismiss)="adokodCel = null" cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Adókód kiválasztása – NAV szabványos adókód (eÁFA)</ion-title></ion-toolbar></ion-header>
    <div class="bv-torzs">
      <div class="n-szuro-sor">
        <input type="search" [(ngModel)]="adokodKereso" placeholder="Keresés: MD66, F29 66, fordított…" autofocus>
        <label style="display:inline-flex;align-items:center;gap:6px">
          <input type="checkbox" [(ngModel)]="adokodMind"> mind (az oldal szerinti szűrés nélkül)</label>
        <span class="spacer"></span>
        <span class="halvany">{{ adokodLathato.length }} kód · frissítés: Törzsadatok → Adókódok</span>
      </div>
      <div class="tabla-wrap">
        <table class="n-racs">
          <thead><tr><th style="width:170px">Standard adókód</th><th style="width:110px">Beszédes</th><th>Leírás</th></tr></thead>
          <tbody>
            <tr *ngFor="let a of adokodLathato" class="kattinthato" (click)="adokodValaszt(a)">
              <td><b>{{ a.kod }}</b></td><td>{{ a.beszedes }}</td><td>{{ a.nev }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ures" *ngIf="!adokodLathato.length">Nincs ide illő adókód – a „mind” jelölővel a teljes katalógus látszik.</div>
      </div>
      <div class="sa-lab"><span class="spacer"></span><button type="button" class="ov-gomb" (click)="adokodCel = null">Mégsem</button></div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ NYITÓ NAPLÓ IMPORT – ELŐNÉZET ═══ -->
<ion-modal [isOpen]="!!nyitoImport" (didDismiss)="nyitoImport = null" cssClass="sorablak-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Nyitó napló importálása – {{ nyitoImport?.ev }}</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="nyitoImport">
        <p class="halvany" style="margin:0">
          Minden sor egy nyitó bizonylat lesz: a főkönyvi számla a saját oldalára, a
          <b>{{ nyitoImport.nyito_szamla }}</b> nyitómérleg-számla vele szemben.
        </p>
        <div class="n-szuro-sor">
          <span>Tartozik: <b>{{ nyitoImport.tartozik | number:'1.0-0' }}</b></span>
          <span>Követel: <b>{{ nyitoImport.kovetel | number:'1.0-0' }}</b></span>
          <span class="cimke" [class.zold]="nyitoImport.egyensulyban" [class.sarga]="!nyitoImport.egyensulyban">
            {{ nyitoImport.egyensulyban ? 'egyensúlyban' : 'nincs egyensúlyban' }}</span>
          <span class="spacer" style="flex:1"></span>
          <span class="halvany">{{ nyitoImport.sorok.length }} sor</span>
        </div>
        <p class="lepes-figyelem" *ngIf="nyitoImport.mar_nyitva">
          <ion-icon name="warning-outline"></ion-icon>
          Ez az év már meg van nyitva – a könyvelés a MEGLÉVŐ nyitó naplót lecseréli erre.
        </p>
        <div *ngIf="nyitoImport.gondok?.length" style="margin:4px 0">
          <div class="lepes-figyelem" *ngFor="let g of nyitoImport.gondok"><ion-icon name="alert-circle-outline"></ion-icon>{{ g }}</div>
        </div>
        <div class="tabla-wrap" style="max-height:46vh">
          <table class="n-racs">
            <thead><tr><th>Főkönyv</th><th>Megnevezés</th><th>Partner</th><th class="num">Tartozik</th><th class="num">Követel</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of nyitoImport.sorok">
                <td><b>{{ s.szamlaszam }}</b> <small class="halvany">{{ szamlaNev(s.szamlaszam) }}</small></td>
                <td class="n-ket-sor">{{ s.megjegyzes }}</td>
                <td>{{ s.partner_nev }}</td>
                <td class="num">{{ s.tartozik ? (s.tartozik | number:'1.0-0') : '' }}</td>
                <td class="num">{{ s.kovetel ? (s.kovetel | number:'1.0-0') : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" [disabled]="!nyitoImport.egyensulyban || nyitoFut" (click)="nyitoKonyvel()">
            <ion-icon name="checkmark"></ion-icon>{{ nyitoFut ? 'Könyvelés…' : 'Könyvelés' }}</button>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" (click)="nyitoImport = null">Mégsem</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Könyvelt bizonylat kötése egy tárgyi eszközhöz (bérleti díj / nem aktivált kiadás) -->
<ion-modal [isOpen]="!!hozamTetel" (didDismiss)="hozamTetel = null" class="ber-urlap-modal" cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Tárgyi eszközhöz rendelés</ion-title>
      <ion-buttons slot="end"><ion-button (click)="hozamTetel = null">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <app-eszkoz-hozam-kotes [ugyfelId]="aktiv.ugyfelId" [tetelId]="hozamTetel" (kesz)="hozamKesz()"></app-eszkoz-hozam-kotes>
    </div>
  </ng-template>
</ion-modal>
